// import { Close } from "@mui/icons-material";
// import {
//   Autocomplete,
//   Button,
//   Dialog,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography
// } from "@mui/material";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axios from "axios";
// import dayjs from "dayjs";
// import { useFormik } from "formik";
// import moment from "moment";
// import React, { memo, useEffect, useRef, useState } from "react";
// import OTPInput from "react-otp-input";
// import { useDispatch } from "react-redux";
// import * as yup from "yup";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { useStyle } from "../style";
// const SalesInfo = ({
//   subCatName,
//   count,
//   setPostData,
//   postData,
//   setReward,
//   thisBill,
//   setDocNameDefault,
//   setThisBill,
//   billPoints,
//   setBillPoints,
//   data,
//   setOp,
//   setDocName,
//   docName,
//   setReturnAmnt,
//   returnAmnt,
//   poDetails,
//   setPoDetails,
//   setEnableRedeem,
//   setMember,
//   selectedMode,
//   setSelectedMode,
//   netTotal,
//   codeRef
// }) => {
//   const classes = useStyle();
//   const dispatch = useDispatch();
//   const [flag, setFlag] = useState(false);
//   const outlet_id = localStorage.getItem("outlet_id");
//   const [returnData, setReturnData] = useState([]);
//   const [returnBar, setReturnBar] = useState([]);
//   const [salesMan, setSalesMan] = useState([]); // salesman id
//   const [billNo, setBillNo] = useState("");
//   const nameRef = useRef(null);
//   const [otName, setOtName] = useState("");
//   const [otpToken, setOtpToken] = useState("");
//   const [otpOpen, setOtpOpen] = useState(false);
//   const [otpEnable, setOtpEnable] = useState(false);
//   const [otpDisable, setOtpDisable] = useState(false)
//   const [channels, setChannels] = useState(null);
//   const mobileRef = useRef(null);
//   const addressRef = useRef(null);
//   const salesmanRef = useRef(null);
//   const [party, setParty] = useState({
//     name: "",
//     mobile: "",
//     address: "",
//     gstin: "",
//   });

//   const [points, setPoints] = useState("");

// const validationSchema = yup.object().shape({
//    otp: yup
//         .string("Enter your otp")
//         .matches(/^\d{4}$/, "Enter a valid 4-digit OTP")
//         .required("Please enter your otp here"),
//   name: yup
//     .string()
//     .matches(/^[A-Za-z\s]*$/, "Only letters and spaces are allowed")
//     .test(
//       "name-or-mobile-filled",
//       "Customer Name is required*",
//       function (value) {
//         const { mobile } = this.parent;
//         // Don't show error if both fields are empty
//         if (!value && !mobile) return true;
//         // If name is present, validate required
//         return !!value;
//       }
//     ),

//   mobile: yup
//     .string()
//     .matches(/^\d{10}$/, "Please enter a valid 10-digit mobile number")
//     .test(
//       "name-or-mobile-filled",
//       "Mobile number is required*",
//       function (value) {
//         const { name } = this.parent;
//         // Don't show error if both fields are empty
//         if (!value && !name) return true;
//         // If mobile is present, validate required
//         return !!value;
//       }
//     ),
// });

//   // const validationSchema = yup.object({
//   //   otp: yup
//   //     .string("Enter your otp")
//   //     .matches(/^\d{4}$/, "Enter a valid 4-digit OTP")
//   //     .required("Please enter your otp here"),
//   //     name: yup
//   //   .string("Enter your name")
//   //   .matches(/^[A-Za-z\s]*$/, "Only letters and spaces are allowed")
//   //   .required("Please enter your name"),  // Name required validation

//   // mobile: yup
//   //   .string("Enter your mobile number")
//   //   .matches(/^\d{10}$/, "Please enter a valid 10-digit mobile number")  // Mobile number format
//   //   .required("Please enter your mobile number"),  // Mobile required validation
//   // });
//   const socialMediaPlatforms = [
//     // { id: 1, fullname: 'Facebook' },
//     // { id: 2, fullname: 'YouTube' },
//     // { id: 3, fullname: 'Instagram' },
//     // { id: 4, fullname: 'TikTok' },
//     // { id: 5, fullname: 'Snapchat' },
//     // { id: 6, fullname: 'X (formerly Twitter)' },
//     // { id: 7, fullname: 'Pinterest' },
//     // { id: 8, fullname: 'Reddit' },
//     // { id: 9, fullname: 'LinkedIn' },
//     // { id: 10, fullname: 'Threads' },
//     // { id: 11, fullname: 'Others' },
//   { id: 1, fullname: "New walk-in" },
//   { id: 2, fullname: "Regular"},
//   { id: 3, fullname: "YouTube" },
//   { id: 4, fullname: "Facebook" },
//   { id: 5, fullname: "Instagram" },
//   { id: 6, fullname: "Others" }
//     // Add more platforms as needed
//   ];

//   function handleOnChange(e) {
//     const { name, value } = e.target;
//     formik.setFieldValue(name, value);
//     if (name === "name") {
//       // Allow only letters and spaces
//       if (/^[A-Za-z\s]*$/.test(value)) {
//         setParty((prev) => ({ ...prev, name: value }));
//       }
//     }
//     else if (name === "mobile") {
//       // Allow only numbers with a max length of 10
//       if (/^\d{0,10}$/.test(value)) {
//         setParty((prev) => ({ ...prev, mobile: value }));
//       }

//       // Reset fields if mobile number is shorter than 10 digits
//       if (value.length < 10) {
//         setParty((prev) => ({ ...prev, name: "", gstin: "", address: "" }));
//         setPoints("");
//         setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
//         setThisBill(0);
//         setOp(false);
//         setEnableRedeem(false);
//         setOtpDisable(false);
//       }
//     }
//     else if (name === "address") {
//       setParty((prev) => ({ ...prev, address: value }));
//     }
//   }

//   function onReturnBillChange(e) {
//     setBillNo(e.target.value);
//   }

//   function enterReturnBill(e) {
//     if (e.key === "Enter") {
//       if (data.length == 0) {
//         dispatch(setSnackbar(true, "error", "please sale any one product"));
//       } else {
//         const returnBill = {
//           docno: billNo.replace("/", "_").replace("-", "_").replace("/", "_"),
//         };
//         axios
//           .post(`/v1/outlet_sales_return_master/getone`, returnBill)
//           .then((res) => {
//             // console.log(res);
//             setReturnData(res.data);
//           })
//           .catch((err) => {
//             console.log(err);
//             dispatch(
//               setSnackbar(true, "error", err.response.data.errors[0].message)
//             );
//           });
//       }
//     }
//   }

//   console.log(billPoints,"billPoints");

//   // function fetchMember() {
//   //   if (postData.mobile.length === 10) {

//   //     axios

//   //       .post("v1/fetch_outlet_member", { mobile: party.mobile })
//   //       .then((res) => {
//   //         console.log(Number(res.data[0].balance_points, "balance points", postData));

//   //         setMember(true);

//   //         setParty((prev) => ({
//   //           ...prev,
//   //           name: res.data[0].party_name,
//   //           gstin: res.data[0].gst_in,
//   //           address: res.data[0].address,
//   //         }));
//   //         formik.setFieldValue("name", res.data[0].party_name || "");

//   //         setPoints(res.data[0].balance_points);
//   //         setBillPoints((prev) => ({
//   //           ...prev,
//   //           total:
//   //             parseFloat(res.data[0].balance_points) + parseFloat(thisBill),
//   //           defaultPoint: parseFloat(res.data[0].balance_points),
//   //         }));
//   //         setReward(parseFloat(res.data[0].balance_points));
//   //         setFlag(true);

//   //         if (Number(res.data[0].balance_points) > 0) {
//   //           setOtpEnable(true);
//   //         }
//   //       })
//   //       .catch((err) => {
//   //         console.log(err.response);

//   //         if (
//   //           err.response?.data?.errors?.[0]?.code === "NOT_FOUND" &&
//   //           err.response?.data?.errors?.[0]?.message === "Member not found" ||
//   //           err.response?.data?.errors?.[0]?.message === ""
//   //         ) {
//   //           // Member not found: Keep mobile number, clear other fields
//   //           // setParty((prev) => ({
//   //           //   ...prev,
//   //           //   name: "",
//   //           //   gstin: "",
//   //           //   address: "",
//   //           // }));
//   //           setPoints(0.0);
//   //           setMember(false);
//   //           setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
//   //           setFlag(false);
//   //           setOtpEnable(false);
//   //           setOp(false);

//   //           console.log("Member not found, keeping mobile number unchanged.");
//   //           return;
//   //         }

//   //         // For all other errors, reset everything including the mobile number
//   //         setParty({
//   //           mobile: "",
//   //           name: "",
//   //           gstin: "",
//   //           address: "",
//   //         });
//   //         setPoints(0.0);
//   //         setMember(false);
//   //         setBillPoints({ total: 0, defaultPoint: 0 });
//   //         setOtpEnable(false);
//   //         setFlag(false);
//   //         setOp(false);

//   //         // Show error message for other errors
//   //         dispatch(
//   //           setSnackbar(true, "error", err.response.data.errors[0].message)
//   //         );
//   //       });
//   //   } else {
//   //     dispatch(setSnackbar(true, "error", "Please enter a 10-digit mobile number"));
//   //   }
//   // }

//   // function fetchMember() {
//   //   if (postData.mobile.length === 10) {
//   //     axios
//   //       .post("v1/fetch_outlet_member", { mobile: party.mobile })
//   //       .then((res) => {
//   //         console.log(Number(res.data[0].balance_points, "balance points", postData));

//   //         setMember(true);

//   //         setParty((prev) => ({
//   //           ...prev,
//   //           name: res.data[0].party_name,
//   //           gstin: res.data[0].gst_in,
//   //           address: res.data[0].address,
//   //         }));
//   //         formik.setFieldValue("name", res.data[0].party_name || "");

//   //         setPoints(res.data[0].balance_points);
//   //         setBillPoints((prev) => ({
//   //           ...prev,
//   //           total: parseFloat(res.data[0].balance_points) + parseFloat(thisBill),
//   //           defaultPoint: parseFloat(res.data[0].balance_points),
//   //         }));
//   //         setReward(parseFloat(res.data[0].balance_points));
//   //         setFlag(true);

//   //         if (Number(res.data[0].balance_points) > 0) {
//   //           setOtpEnable(true);
//   //         }
//   //       })
//   //       .catch((err) => {
//   //         const error = err.response?.data?.errors?.[0];
//   //         console.log(err.response);

//   //         // Handle "Member not found" with empty message
//   //         if (error?.message === "") {
//   //         // if (error?.code === "NOT_FOUND" && error?.message === "") {
//   //           setParty({
//   //             mobile: "",
//   //             name: "",
//   //             gstin: "",
//   //             address: "",
//   //           });
//   //           setPoints(0.0);
//   //           setMember(false);
//   //           setBillPoints({ total: 0, defaultPoint: 0 });
//   //           setOtpEnable(false);
//   //           setFlag(false);
//   //           setOp(false);

//   //           // Refocus on mobile input field
//   //           if (mobileRef?.current) {

//   //             setTimeout(() => {
//   //               formik.setFieldValue("mobile","");
//   //               formik.setFieldValue("name","");
//   //               mobileRef.current.focus();
//   //             }, 100); // slight delay ensures refocus
//   //           }

//   //           // dispatch(setSnackbar(true, "error", "Member not found"));
//   //           return;
//   //         }

//   //         // Other errors
//   //         setParty({
//   //           mobile: "",
//   //           name: "",
//   //           gstin: "",
//   //           address: "",
//   //         });
//   //         setPoints(0.0);
//   //         setMember(false);
//   //         setBillPoints({ total: 0, defaultPoint: 0 });
//   //         setOtpEnable(false);
//   //         setFlag(false);
//   //         setOp(false);

//   //         dispatch(setSnackbar(true, "error", error?.message || "Something went wrong"));
//   //       });
//   //   } else {

//   //     dispatch(setSnackbar(true, "error", "Please enter a 10-digit mobile number"));
//   //   }
//   // }
//   function fetchMember() {
//     if (postData.mobile.length === 10) {
//       axios
//         .post("v1/fetch_outlet_member", { mobile: party.mobile })
//         .then((res) => {
//           const data = res.data[0];
//           console.log(Number(data.balance_points), "balance points", postData);

//           setMember(true);

//           setParty((prev) => ({
//             ...prev,
//             name: data.party_name,
//             gstin: data.gst_in,
//             address: data.address,
//           }));
//           formik.setFieldValue("name", data.party_name || "");

//           const points = parseFloat(data.balance_points);
//           setPoints(points);
//           setBillPoints((prev) => ({
//             ...prev,
//             total: points + parseFloat(thisBill),
//             defaultPoint: points,
//           }));
//           setReward(points);
//           setFlag(true);

//           if (points > 0) {
//             setOtpEnable(true);
//           }
//         })
//         .catch((err) => {
//           const error = err.response?.data?.errors?.[0];
//           const message = error?.message || "";

//           if (error?.code === "NOT_FOUND") {
//             // If message is empty, clear and refocus the mobile field
//             if (message.trim() === "" && mobileRef?.current) {
//               formik.setFieldValue("mobile", "");
//               formik.setFieldValue("name", "");
//               setTimeout(() => {
//                 mobileRef.current.focus();
//               }, 100);
//             }

//             // Clear member details
//             setPoints(0.0);
//             setMember(false);
//             setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
//             setFlag(false);
//             setOtpEnable(false);
//             setOp(false);

//             console.log("Member not found, keeping mobile number unchanged.");
//             return;
//           }

//           // For other errors, reset everything
//           setParty({
//             mobile: "",
//             name: "",
//             gstin: "",
//             address: "",
//           });
//           setPoints(0.0);
//           setMember(false);
//           setBillPoints({ total: 0, defaultPoint: 0 });
//           setOtpEnable(false);
//           setFlag(false);
//           setOp(false);

//           dispatch(
//             setSnackbar(true, "error", message || "Something went wrong")
//           );
//         });
//     } else {
//       dispatch(setSnackbar(true, "error", "Please enter a 10-digit mobile number"));
//       formik.setFieldValue("mobile", "");
//       setTimeout(() => {
//         mobileRef?.current?.focus();
//       }, 100);
//     }
//   }

//   console.log(thisBill,"thisBill");

//   function handleOtp() {
//     // formik.resetForm()
//     axios
//       .post(`/v1/sendotp`, { mobile: party.mobile })
//       .then((res) => {
//         console.log(res);
//         setOtpToken(res.data.token);
//         setOtpOpen(true);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   const handleKeyPress = (event, currentFieldRef, nextFieldRef) => {
//     if (event.key === 'Enter') {
//       event.preventDefault(); // Prevent form submission on Enter
//       if (currentFieldRef === mobileRef) {
//         fetchMember();

//       }
//       if (nextFieldRef && nextFieldRef.current) {
//         nextFieldRef.current.focus();
//       }
//     }
//   };
//   const handleSalesMan = (e, value) => {
//     setPoDetails((prev) => ({ ...prev, salesManId: value }));
//   };
//   const handleModeChange = (event) => {
//     const mode = event.target.value;
//     setSelectedMode(mode);
//     modeCheck(mode);
//     console.log(mode,"modecheckdata");

//   };

//   const handleChange = (e) => {
//     setPoDetails((prevState) => ({ ...prevState, docDate: dayjs(e).format() }));
//   };
// function modeCheck(mode) {
//   const baseAmount = returnAmnt ? postData.amount - returnAmnt : postData.amount;

//   // Adjust amount based on loyalty_redem and apply less_amount conditionally
//   let adjustedAmount;
//   if (postData.loyalty_redem) {
//     adjustedAmount = baseAmount - postData.loyalty_redem;
//   } else {
//     adjustedAmount = baseAmount;
//   }

//   // Apply less_amount condition separately
//   adjustedAmount -= postData.less_amount || 0;

//   console.log("Cash amount 1", mode, "Mode:", returnAmnt, postData.amount);
//   console.log(adjustedAmount, "adjustedAmount");

//   // Set negative adjusted amount if the final calculation is negative
//   const finalAmount = adjustedAmount < 0 ? `-${Math.abs(adjustedAmount)}` : adjustedAmount;

//   if (mode === "cash") {
//     setPostData((prev) => ({
//       ...prev,
//       card_amount: "0",
//       cash_amount: finalAmount,
//       upi_amount: "0",
//     }));
//   } else if (mode === "card") {
//     setPostData((prev) => ({
//       ...prev,
//       card_amount: finalAmount,
//       cash_amount: "0",
//       upi_amount: "0",
//     }));
//   } else if (mode === "upi") {
//     setPostData((prev) => ({
//       ...prev,
//       card_amount: "0",
//       cash_amount: "0",
//       upi_amount: finalAmount,
//     }));
//   }
// }
// function getSalesMan() {
//     axios
//       .get(`v1/SalesMan/outlets/${outlet_id}`)
//       .then((res) => setSalesMan(res.data))
//       .catch((err) => {
//         console.log(err);
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }
//   useEffect(() => {
//     getSalesMan(); // SalesMan
//     axios
//       .get(`/v1/outlet_sales_master/${outlet_id}`)
//       .then((res) => {
//         let input = res.data.Docno;
//         setDocNameDefault(input);
//         let output = input.replace(/_/g, "/").replace(/(\d+)_(\d+)_(\d+)/, "$1-$2/$3");
//         setDocName(output);
//       })
//       .catch((err) => {
//         console.log(err.response.data);
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }, []);
//   useEffect(() => {
//     if (returnBar.length > 0) {
//       let return_amt = returnBar.reduce((accumulator, item) => accumulator + parseFloat(item.mrp), 0);
//       setReturnAmnt(return_amt);
//     }
//     else{
//       setReturnAmnt(0)
//     }
//   }, [returnBar]);
//   useEffect(() => {
//     if (returnBar.length > 0) {
//       let return_amt = returnBar.reduce((accumulator, item) => accumulator + parseFloat(item.mrp), 0);
//       setReturnAmnt(return_amt);

//       // Call modeCheck function if returnBar has items and set the cash amount accordingly
//       modeCheck(selectedMode, return_amt); // Pass the return amount to modeCheck
//     } else {
//       setReturnAmnt(0);
//       modeCheck(selectedMode, 0); // Reset amounts if returnBar is empty
//     }
//   }, [returnBar, selectedMode]);
//   useEffect(() => {
//     axios(`/v1/outlet/info/${outlet_id}`)
//       .then((res) => {
//         setOtName(res.data.outlet_type_name);
//       })

//       .catch((err) => {
//         console.log(err);
//         dispatch(
//           setSnackbar(true, "error", err.response.data.errors[0].message)
//         );
//       });
//   }, [outlet_id]);

//   useEffect(() => {
//     setPostData((prev) => ({
//       ...prev,
//       docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
//       mode: selectedMode,
//       party_name: party.name,
//       address: party.address,
//       mobile: party.mobile,
//       return_billno: billNo,
//       return_amount: returnAmnt,
//     }));
//     modeCheck(selectedMode);
//     if (poDetails.salesManId !== null) {
//       setPostData((prev) => ({
//         ...prev,
//         salesman_id: poDetails.salesManId.id,
//         channels: channels?.fullname || "",
//       }));
//     }
//   }, [poDetails, party, selectedMode, returnAmnt, billNo,channels]);
// console.log(channels,"channels");

//   useEffect(() => {
//     if (data.length > 0 && (party.mobile != "") & (points == "")) {
//       fetchMember();
//     }
//   }, [data]);
//   const onOtpSubmit = () => {
//     const config = {
//       headers: {
//         Authorization: `Bearer ${otpToken}`,
//       },
//     };
//     axios
//       .post(`/v1/verifyotp`, { otp: formik.values.otp }, config)
//       .then((res) => {
//         console.log(res);
//         if(res.data.success){
//         dispatch(setSnackbar(true, "success", res.data.message));
//         setOtpOpen(false);
//         setOp(true);
//         setEnableRedeem(true);
//         setOtpDisable(true)
//         // formik.resetForm()
//         }
//         else{
//           dispatch(setSnackbar(true, "error", res.data.message));
//         }

//       })
//       .catch((err) => {
//         console.log(err);
//         dispatch(setSnackbar(true, "error", err.data.message));
//         setOtpOpen(false);
//         formik.resetForm()
//       });
//   };
//   const formik = useFormik({
//     initialValues: {
//       otp: "",
//       name: "",
//       mobile: ""
//     },
//     validationSchema: validationSchema,
//     onSubmit: onOtpSubmit,
//   });
// console.log(thisBill,"thisBill");
// useEffect(() => {
//   if (points > 0) {
//     setChannels(socialMediaPlatforms.find(opt => opt.fullname === "Regular"));
//   }
// }, [points]);

//   return (
//     <Grid container spacing={2} className="p-2 h-full">
//       <Grid item lg={4}>
//         <TextField autoComplete="off"
//          inputRef={mobileRef}
//          size="small" label="Mobile"
//          fullWidth name="mobile"
//           // value={party.mobile}
//           value={formik.values.mobile}
//            onChange={handleOnChange}
//           // onChange={formik.handleChange}
//              onKeyDown={(e) => handleKeyPress(e, mobileRef,nameRef)}
//              onBlur={formik.handleBlur}
//         //        error={formik.touched.mobile && Boolean(formik.errors.mobile)}
//         // helperText={formik.touched.mobile && formik.errors.mobile}
//         error={
//           formik.touched.mobile &&
//           !!formik.errors.mobile &&
//           formik.values.mobile !== ""
//         }
//         helperText={
//           formik.touched.mobile &&
//           formik.values.mobile !== "" &&
//           formik.errors.mobile
//         }

//          />
//         <TextField sx={{ marginBlock: 1.5 }}
//          inputRef={nameRef} size="small"
//           label="Customer Name"
//            fullWidth name="name"
//             // value={party.name}
//             value={formik.values.name }
//             // onChange={formik.handleChange}
//              onChange={handleOnChange}
//               disabled={flag}
//               onKeyDown={(e) => handleKeyPress(e,nameRef, addressRef)}
//               onBlur={formik.handleBlur}
//               // error={formik.touched.name && Boolean(formik.errors.name)}

//               // helperText={formik.touched.name && formik.errors.name}

//               error={
//                 formik.touched.name &&
//                 Boolean(formik.errors.name) &&
//                 formik.values.mobile !== ""
//               }
//               helperText={
//                 formik.touched.name &&
//                 formik.errors.name &&
//                 formik.values.mobile !== ""
//                   ? formik.errors.name
//                   : ""
//               }
//          />
//         <TextField  inputRef={addressRef} size="small" label="Address" fullWidth name="address" multiline sx={{ marginBottom: 1.5 }} value={party.address} onChange={handleOnChange} disabled={flag} onKeyDown={(e)=> handleKeyPress(e,addressRef,salesmanRef) } />
//         <div className="flex">
//           <TextField size="small" label="Points" name="points" value={points} InputProps={{ readOnly: true }} disabled={!flag} sx={{marginInline:0.5}}/>
//           <TextField size="small" label="This Bill" name="billPoints" value={parseFloat(thisBill).toFixed(0)} InputProps={{ readOnly: true }} disabled={!flag} sx={{marginInline:0.5}}/>
//           <TextField size="small" label="Total" name="Total" value={parseFloat(billPoints.total).toFixed(0)} InputProps={{ readOnly: true }} disabled={!flag} sx={{marginInline:0.5}} />
//         </div>
//         {otpEnable && party.mobile != "" && (
//           <Button onClick={handleOtp} variant={otpDisable ? "" : "contained"} disabled={otpDisable} sx={{ marginBlock: "10px" }}>Send Otp for redeem points</Button>
//         )}
//       </Grid>
//       <Grid item lg={4}>
//         {otName != "OWN" && (
//           <TextField size="small" label="GSTIN" fullWidth  name="gstin" value={party.gstin} onChange={handleOnChange}/>
//         )}

//         <Typography variant="body1">Mode</Typography>
//         <FormControl sx={{ display: "flex" }}>
//           <RadioGroup
//             aria-labelledby="demo-radio-buttons-group-label"
//             name="mode"
//             id="mode"
//             sx={{ flexDirection: "row", display: "flex" }}
//             value={selectedMode}
//             onChange={handleModeChange}
//           >
//             <FormControlLabel value="cash" control={<Radio size="small" />} label="Cash"/>
//             <FormControlLabel value="card" control={<Radio size="small" />} label="Card" />
//             <FormControlLabel value="upi" control={<Radio size="small" />} label="UPI" />
//             <FormControlLabel value="mixed" control={<Radio size="small" />} label="Mixed Pay"/>
//           </RadioGroup>
//         </FormControl>
//         <TextField size="small" label="Return bill" fullWidth name="Return bill" sx={{ marginBottom: 1.5 }} onChange={onReturnBillChange} onKeyPress={enterReturnBill}/>
//         <Autocomplete
//           options={returnData}
//           multiple={true}
//           disableClearable
//           limitTags={3}
//           size="small"
//           getOptionLabel={(option) => option.barcode}
//           onChange={(e, value) => setReturnBar(value)}
//           isOptionEqualToValue={(option, value) => option.barcode === value.barcode}
//           disabled={returnData.length === 0}
//           sx={{ marginBlock: 1 }}
//           renderInput={(params) => (
//             <TextField {...params} label="Select Barcode" autoComplete="off" />
//           )}
//         />
//       </Grid>
//       <Grid item lg={4}>
//         <TextField size="small" label="Bill No" fullWidth value={docName.replace(/\/(\d+)\/(\d+)\//, "/$1-$2/")}
//           InputProps={{ readOnly: true }}
//         />

//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DatePicker
//             onChange={(e) => handleChange(e)}
//             value={dayjs(poDetails.docDate)}
//             label="Bill Date"
//             disabled
//             slotProps={{
//               textField: {
//                 size: "small",
//               },
//             }}
//             sx={{ width: "100%", marginBlock: 1.5 }}
//           />
//         </LocalizationProvider>

//         <Autocomplete
//           id="salesman"
//           name="salesman"
//           size="small"
//           options={salesMan}
//           getOptionLabel={(option) =>
//             `${option.sales_man_name} - ${option.sales_man_code}`
//           }
//           value={poDetails.salesManId}
//           onChange={handleSalesMan}
//           disableClearable
//           isOptionEqualToValue={(option, value) => option.id === value.id}
//           sx={{ marginBlock: 1 }}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               label="Salesman"
//               autoComplete="off"
//               inputRef={salesmanRef}
//               // required
//             />
//           )}
//         />
//    {/* <Autocomplete
//       size="small"
//       options={socialMediaPlatforms}
//       disableClearable
//       value={channels}
//       sx={{ marginBlock: 1 }}
//       onChange={(e, value) => setChannels(value)}
//       getOptionLabel={(option) => option.fullname}
//       renderInput={(params) => <TextField {...params} label="Select Channels"/>}
//       // multiple
//     /> */}
//     <Autocomplete
//       size="small"
//       options={socialMediaPlatforms}
//       required
//       disableClearable
//       value={channels}
//       sx={{ marginBlock: 1 }}
//       // ✅ if points > 0, force "Regular" and disable selection
//       onChange={(e, value) => {
//         if (points > 0) {
//           setChannels(socialMediaPlatforms.find(opt => opt.fullname === "Regular"));
//         } else {
//           setChannels(value);
//         }
//       }}
//       getOptionLabel={(option) => option.fullname}
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           label="Select Channels"
//         />
//       )}
//       disabled={points > 0} // ✅ Disable Autocomplete if points > 0
//     />
//         <Typography
//           sx={{
//             fontWeight: "bold",
//             textAlign: "right",
//             backgroundColor: "#ba68c8",
//             color: "#fff",
//             padding: "8px 20px",
//           }}
//         >
//           {subCatName} Total available Qty is : {count}
//         </Typography>
//       </Grid>
//       <Dialog
//         open={otpOpen}
//         sx={{ width: "800px !important", margin: "0 auto" }}
//       >
//         <Grid
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "10px",
//           }}
//         >
//           <Typography
//             sx={{
//               fontSize: 20,
//               color: "#004AAD",
//               fontWeight: "bold",
//               marginRight: "50px",
//             }}
//           >
//             please enter the OTP for this number
//             <span style={{ fontSize: 20, color: "#000", fontWeight: "bold" }}>
//               {party.mobile}
//             </span>
//           </Typography>
//           <IconButton
//             onClick={() => {
//               setOtpOpen(false);
//             }}
//           >
//             <Close />
//           </IconButton>
//         </Grid>
//         <Divider />

//         <Grid sx={{ padding: "20px" }}>
//           <OTPInput
//             shouldAutoFocus
//             name="otp"
//             id="otp"
//             containerStyle={classes.otpContainer}
//             inputStyle={classes.otpField}
//             onChange={(otp) => formik.setFieldValue("otp", otp)}
//             numInputs={4}
//             renderInput={(props) => <input {...props} />}
//             value={formik.values.otp}
//             error={formik.touched.otp && Boolean(formik.errors.otp)}
//             helperText={formik.touched.otp && formik.errors.otp}
//           />
//           <Grid sx={{ textAlign: "end" }}>
//             <Button variant="contained" onClick={formik.handleSubmit}>Verify OTP</Button>
//           </Grid>
//         </Grid>
//       </Dialog>
//     </Grid>
//   );
// };

// export default memo(SalesInfo);

// 17-09-2025 return bill dropdown changes to autocomplete

// import { Close } from "@mui/icons-material";
// import {
//   Autocomplete,
//   Button,
//   Dialog,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography
// } from "@mui/material";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axios from "axios";
// import dayjs from "dayjs";
// import { useFormik } from "formik";
// import moment from "moment";
// import React, { memo, useEffect, useRef, useState } from "react";
// import OTPInput from "react-otp-input";
// import { useDispatch } from "react-redux";
// import * as yup from "yup";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { useStyle } from "../style";

// const SalesInfo = ({
//   subCatName,
//   count,
//   setPostData,
//   postData,
//   setReward,
//   thisBill,
//   setDocNameDefault,
//   setThisBill,
//   billPoints,
//   setBillPoints,
//   data,
//   setOp,
//   setDocName,
//   docName,
//   setReturnAmnt,
//   returnAmnt,
//   poDetails,
//   setPoDetails,
//   setEnableRedeem,
//   setMember,
//   selectedMode,
//   setSelectedMode,
//   netTotal,
//   codeRef
// }) => {
//   const classes = useStyle();
//   const dispatch = useDispatch();
//   const [flag, setFlag] = useState(false);
//   const outlet_id = localStorage.getItem("outlet_id");
//   const [returnData, setReturnData] = useState([]);
//   const [returnBar, setReturnBar] = useState([]);
//   const [salesMan, setSalesMan] = useState([]);
//   const [billNo, setBillNo] = useState("");
//   const nameRef = useRef(null);
//   const [otName, setOtName] = useState("");
//   const [otpToken, setOtpToken] = useState("");
//   const [otpOpen, setOtpOpen] = useState(false);
//   const [otpEnable, setOtpEnable] = useState(false);
//   const [otpDisable, setOtpDisable] = useState(false);
//   const [channels, setChannels] = useState(null);
//   const mobileRef = useRef(null);
//   const addressRef = useRef(null);
//   const salesmanRef = useRef(null);
//   const [party, setParty] = useState({
//     name: "",
//     mobile: "",
//     address: "",
//     gstin: "",
//   });
//   const [points, setPoints] = useState("");

//   // States for docno Autocomplete with only most recent bill shown
//   const [returnDocNoList, setReturnDocNoList] = useState([]);
//   const [returnDocNoLoading, setReturnDocNoLoading] = useState(false);

//   // Track used return bill number to disable it in Autocomplete options
//   const [usedReturnBill, setUsedReturnBill] = useState(null);

//   const validationSchema = yup.object().shape({
//     otp: yup
//       .string("Enter your otp")
//       .matches(/^\d{4}$/, "Enter a valid 4-digit OTP")
//       .required("Please enter your otp here"),
//     name: yup
//       .string()
//       .matches(/^[A-Za-z\s]*$/, "Only letters and spaces are allowed")
//       .test(
//         "name-or-mobile-filled",
//         "Customer Name is required*",
//         function (value) {
//           const { mobile } = this.parent;
//           if (!value && !mobile) return true;
//           return !!value;
//         }
//       ),
//     mobile: yup
//       .string()
//       .matches(/^\d{10}$/, "Please enter a valid 10-digit mobile number")
//       .test(
//         "name-or-mobile-filled",
//         "Mobile number is required*",
//         function (value) {
//           const { name } = this.parent;
//           if (!value && !name) return true;
//           return !!value;
//         }
//       ),
//   });

//   const socialMediaPlatforms = [
//     { id: 1, fullname: "Facebook" },
//     { id: 2, fullname: "YouTube" },
//     { id: 3, fullname: "Instagram" },
//     { id: 4, fullname: "Others" },
//     { id: 5, fullname: "New walk in" },
//     { id: 6, fullname: "Regular" },
//   ];

//   function handleOnChange(e) {
//     const { name, value } = e.target;
//     formik.setFieldValue(name, value);
//     if (name === "name") {
//       if (/^[A-Za-z\s]*$/.test(value)) {
//         setParty((prev) => ({ ...prev, name: value }));
//       }
//     } else if (name === "mobile") {
//       if (/^\d{0,10}$/.test(value)) {
//         setParty((prev) => ({ ...prev, mobile: value }));
//       }
//       if (value.length === 10) {
//         setReturnDocNoLoading(true);
//         axios
//           .get(`/v1/return/docno/${outlet_id}/${value}`)
//           .then((res) => {
//             const docnos = res.data || [];
//             if (docnos.length === 0) {
//               setReturnDocNoList([]);
//               setReturnDocNoLoading(false);
//               return;
//             }
//             // Find max date
//             const maxDate = docnos.reduce(
//               (max, item) =>
//                 new Date(item.docdate) > new Date(max) ? item.docdate : max,
//               docnos[0].docdate
//             );

//             // Filter bills with the max date
//             const latestDateBills = docnos.filter((d) => d.docdate === maxDate);

//             // Sort by numeric suffix after last underscore descending
//             latestDateBills.sort((a, b) => {
//               const suffixA = parseInt(a.docno.split("_").pop(), 10) || 0;
//               const suffixB = parseInt(b.docno.split("_").pop(), 10) || 0;
//               return suffixB - suffixA; // descending order
//             });

//             // Set only the first (most recent) bill of that day
//             setReturnDocNoList(latestDateBills.length > 0 ? [latestDateBills[0]] : []);
//             setReturnDocNoLoading(false);
//           })
//           .catch((err) => {
//             setReturnDocNoList([]);
//             setReturnDocNoLoading(false);
//           });
//       } else {
//         setReturnDocNoList([]);
//       }
//       if (value.length < 10) {
//         setParty((prev) => ({ ...prev, name: "", gstin: "", address: "" }));
//         setPoints("");
//         setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
//         setThisBill(0);
//         setOp(false);
//         setEnableRedeem(false);
//         setOtpDisable(false);
//       }
//     } else if (name === "address") {
//       setParty((prev) => ({ ...prev, address: value }));
//     }
//   }

//   function onReturnBillUsed(docno) {
//     setUsedReturnBill(docno);
//     setBillNo(docno);
//     const returnBill = {
//       docno: docno.replace("/", "_").replace("-", "_").replace("/", "_"),
//     };
//     axios
//       .post(`/v1/outlet_sales_return_master/getone`, returnBill)
//       .then((res) => setReturnData(res.data))
//       .catch((err) =>
//         dispatch(
//           setSnackbar(
//             true,
//             "error",
//             err.response?.data?.errors?.[0]?.message || "Error"
//           )
//         )
//       );
//   }

//   function enterReturnBill(e) {
//     if (data.length === 0) {
//       dispatch(setSnackbar(true, "error", "please sale any one product"));
//     } else {
//       const value = e.target.value || billNo;
//       onReturnBillUsed(value);
//     }
//   }

//   function fetchMember() {
//     if (postData.mobile.length === 10) {
//       axios
//         .post("v1/fetch_outlet_member", { mobile: party.mobile })
//         .then((res) => {
//           const data = res.data[0];
//           setMember(true);
//           setParty((prev) => ({
//             ...prev,
//             name: data.party_name,
//             gstin: data.gst_in,
//             address: data.address,
//           }));
//           formik.setFieldValue("name", data.party_name || "");
//           const points = parseFloat(data.balance_points);
//           setPoints(points);
//           setBillPoints((prev) => ({
//             ...prev,
//             total: points + parseFloat(thisBill),
//             defaultPoint: points,
//           }));
//           setReward(points);
//           setFlag(true);
//           if (points > 0) {
//             setOtpEnable(true);
//           }
//         })
//         .catch((err) => {
//           const error = err.response?.data?.errors?.[0];
//           const message = error?.message || "";
//           if (error?.code === "NOT_FOUND") {
//             if (message.trim() === "" && mobileRef?.current) {
//               formik.setFieldValue("mobile", "");
//               formik.setFieldValue("name", "");
//               setTimeout(() => {
//                 mobileRef.current.focus();
//               }, 100);
//             }
//             setPoints(0.0);
//             setMember(false);
//             setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
//             setFlag(false);
//             setOtpEnable(false);
//             setOp(false);
//             return;
//           }
//           setParty({
//             mobile: "",
//             name: "",
//             gstin: "",
//             address: "",
//           });
//           setPoints(0.0);
//           setMember(false);
//           setBillPoints({ total: 0, defaultPoint: 0 });
//           setOtpEnable(false);
//           setFlag(false);
//           setOp(false);
//           dispatch(
//             setSnackbar(true, "error", message || "Something went wrong")
//           );
//         });
//     } else {
//       dispatch(setSnackbar(true, "error", "Please enter a 10-digit mobile number"));
//       formik.setFieldValue("mobile", "");
//       setTimeout(() => {
//         mobileRef?.current?.focus();
//       }, 100);
//     }
//   }

//   function handleOtp() {
//     axios
//       .post(`/v1/sendotp`, { mobile: party.mobile })
//       .then((res) => {
//         setOtpToken(res.data.token);
//         setOtpOpen(true);
//       })
//       .catch(() => { });
//   }

//   const handleKeyPress = (event, currentFieldRef, nextFieldRef) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//       if (currentFieldRef === mobileRef) {
//         fetchMember();
//       }
//       if (nextFieldRef && nextFieldRef.current) {
//         nextFieldRef.current.focus();
//       }
//     }
//   };

//   const handleSalesMan = (e, value) => {
//     setPoDetails((prev) => ({ ...prev, salesManId: value }));
//   };

//   const handleModeChange = (event) => {
//     const mode = event.target.value;
//     setSelectedMode(mode);
//     modeCheck(mode);
//   };

//   const handleChange = (e) => {
//     setPoDetails((prevState) => ({ ...prevState, docDate: dayjs(e).format() }));
//   };

//   function modeCheck(mode) {
//     const baseAmount = returnAmnt ? postData.amount - returnAmnt : postData.amount;
//     let adjustedAmount;
//     if (postData.loyalty_redem) {
//       adjustedAmount = baseAmount - postData.loyalty_redem;
//     } else {
//       adjustedAmount = baseAmount;
//     }
//     adjustedAmount -= postData.less_amount || 0;
//     const finalAmount = adjustedAmount < 0 ? `-${Math.abs(adjustedAmount)}` : adjustedAmount;
//     if (mode === "cash") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: "0",
//         cash_amount: finalAmount,
//         upi_amount: "0",
//       }));
//     } else if (mode === "card") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: finalAmount,
//         cash_amount: "0",
//         upi_amount: "0",
//       }));
//     } else if (mode === "upi") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: "0",
//         cash_amount: "0",
//         upi_amount: finalAmount,
//       }));
//     }
//   }

//   function getSalesMan() {
//     axios
//       .get(`v1/SalesMan/outlets/${outlet_id}`)
//       .then((res) => setSalesMan(res.data))
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }

//   useEffect(() => {
//     getSalesMan();
//     axios
//       .get(`/v1/outlet_sales_master/${outlet_id}`)
//       .then((res) => {
//         let input = res.data.Docno;
//         setDocNameDefault(input);
//         let output = input.replace(/_/g, "/").replace(/(\d+)_(\d+)_(\d+)/, "$1-$2/$3");
//         setDocName(output);
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }, []);

//   useEffect(() => {
//     if (returnBar.length > 0) {
//       let return_amt = returnBar.reduce(
//         (accumulator, item) => accumulator + parseFloat(item.mrp),
//         0
//       );
//       setReturnAmnt(return_amt);
//     } else {
//       setReturnAmnt(0);
//     }
//   }, [returnBar]);

//   useEffect(() => {
//     if (returnBar.length > 0) {
//       let return_amt = returnBar.reduce(
//         (accumulator, item) => accumulator + parseFloat(item.mrp),
//         0
//       );
//       setReturnAmnt(return_amt);
//       modeCheck(selectedMode, return_amt);
//     } else {
//       setReturnAmnt(0);
//       modeCheck(selectedMode, 0);
//     }
//   }, [returnBar, selectedMode]);

//   useEffect(() => {
//     axios(`/v1/outlet/info/${outlet_id}`)
//       .then((res) => {
//         setOtName(res.data.outlet_type_name);
//       })
//       .catch((err) => {
//         dispatch(
//           setSnackbar(true, "error", err.response.data.errors[0].message)
//         );
//       });
//   }, [outlet_id]);

//   // Prefill channels to "Regular" when points > 0
//   useEffect(() => {
//     if (points > 0) {
//       const regularOption = socialMediaPlatforms.find((opt) => opt.fullname === "Regular");
//       if (channels?.fullname !== "Regular") {
//         setChannels(regularOption);
//       }
//     }
//   }, [points]);

//   useEffect(() => {
//     setPostData((prev) => ({
//       ...prev,
//       docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
//       mode: selectedMode,
//       party_name: party.name,
//       address: party.address,
//       mobile: party.mobile,
//       return_billno: billNo,
//       return_amount: returnAmnt,
//     }));
//     modeCheck(selectedMode);
//     if (poDetails.salesManId !== null) {
//       setPostData((prev) => ({
//         ...prev,
//         salesman_id: poDetails.salesManId.id,
//         channels: channels?.fullname || "",
//       }));
//     }
//   }, [poDetails, party, selectedMode, returnAmnt, billNo, channels]);

//   useEffect(() => {
//     if (data.length > 0 && party.mobile !== "" && points === "") {
//       fetchMember();
//     }
//   }, [data]);

//   const onOtpSubmit = () => {
//     const config = {
//       headers: {
//         Authorization: `Bearer ${otpToken}`,
//       },
//     };
//     axios
//       .post(`/v1/verifyotp`, { otp: formik.values.otp }, config)
//       .then((res) => {
//         if (res.data.success) {
//           dispatch(setSnackbar(true, "success", res.data.message));
//           setOtpOpen(false);
//           setOp(true);
//           setEnableRedeem(true);
//           setOtpDisable(true);
//         } else {
//           dispatch(setSnackbar(true, "error", res.data.message));
//         }
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.data.message));
//         setOtpOpen(false);
//         formik.resetForm();
//       });
//   };

//   const formik = useFormik({
//     initialValues: {
//       otp: "",
//       name: "",
//       mobile: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: onOtpSubmit,
//   });

//   // Map returnDocNoList to disable used return bill
//   const filteredReturnDocNoList = returnDocNoList.map((option) => ({
//     ...option,
//     disabled: usedReturnBill === option.docno,
//   }));

//   return (
//     <Grid container spacing={2} className="p-2 h-full">
//       <Grid item lg={4}>
//         <TextField
//           autoComplete="off"
//           inputRef={mobileRef}
//           size="small"
//           label="Mobile"
//           fullWidth
//           name="mobile"
//           value={formik.values.mobile}
//           onChange={handleOnChange}
//           onKeyDown={(e) => handleKeyPress(e, mobileRef, nameRef)}
//           onBlur={formik.handleBlur}
//           error={
//             formik.touched.mobile &&
//             !!formik.errors.mobile &&
//             formik.values.mobile !== ""
//           }
//           helperText={
//             formik.touched.mobile &&
//             formik.values.mobile !== "" &&
//             formik.errors.mobile
//           }
//         />
//         <TextField
//           sx={{ marginBlock: 1.5 }}
//           inputRef={nameRef}
//           size="small"
//           label="Customer Name"
//           fullWidth
//           name="name"
//           value={formik.values.name}
//           onChange={handleOnChange}
//           disabled={flag}
//           onKeyDown={(e) => handleKeyPress(e, nameRef, addressRef)}
//           onBlur={formik.handleBlur}
//           error={
//             formik.touched.name &&
//             Boolean(formik.errors.name) &&
//             formik.values.mobile !== ""
//           }
//           helperText={
//             formik.touched.name &&
//             formik.errors.name &&
//             formik.values.mobile !== ""
//               ? formik.errors.name
//               : ""
//           }
//         />
//         <TextField
//           inputRef={addressRef}
//           size="small"
//           label="Address"
//           fullWidth
//           name="address"
//           multiline
//           sx={{ marginBottom: 1.5 }}
//           value={party.address}
//           onChange={handleOnChange}
//           disabled={flag}
//           onKeyDown={(e) => handleKeyPress(e, addressRef, salesmanRef)}
//         />
//         <div className="flex">
//           <TextField
//             size="small"
//             label="Points"
//             name="points"
//             value={points}
//             InputProps={{ readOnly: true }}
//             disabled={!flag}
//             sx={{ marginInline: 0.5 }}
//           />
//           <TextField
//             size="small"
//             label="This Bill"
//             name="billPoints"
//             value={parseFloat(thisBill).toFixed(0)}
//             InputProps={{ readOnly: true }}
//             disabled={!flag}
//             sx={{ marginInline: 0.5 }}
//           />
//           <TextField
//             size="small"
//             label="Total"
//             name="Total"
//             value={parseFloat(billPoints.total).toFixed(0)}
//             InputProps={{ readOnly: true }}
//             disabled={!flag}
//             sx={{ marginInline: 0.5 }}
//           />
//         </div>
//         {otpEnable && party.mobile !== "" && (
//           <Button
//             onClick={handleOtp}
//             variant={otpDisable ? "" : "contained"}
//             disabled={otpDisable}
//             sx={{ marginBlock: "10px" }}
//           >
//             Send Otp for redeem points
//           </Button>
//         )}
//       </Grid>
//       <Grid item lg={4}>
//         {otName !== "OWN" && (
//           <TextField
//             size="small"
//             label="GSTIN"
//             fullWidth
//             name="gstin"
//             value={party.gstin}
//             onChange={handleOnChange}
//           />
//         )}
//         <Typography variant="body1">Mode</Typography>
//         <FormControl sx={{ display: "flex" }}>
//           <RadioGroup
//             aria-labelledby="demo-radio-buttons-group-label"
//             name="mode"
//             id="mode"
//             sx={{ flexDirection: "row", display: "flex" }}
//             value={selectedMode}
//             onChange={handleModeChange}
//           >
//             <FormControlLabel
//               value="cash"
//               control={<Radio size="small" />}
//               label="Cash"
//             />
//             <FormControlLabel
//               value="card"
//               control={<Radio size="small" />}
//               label="Card"
//             />
//             <FormControlLabel
//               value="upi"
//               control={<Radio size="small" />}
//               label="UPI"
//             />
//             <FormControlLabel
//               value="mixed"
//               control={<Radio size="small" />}
//               label="Mixed Pay"
//             />
//           </RadioGroup>
//         </FormControl>
//         {/* Return bill Autocomplete with only latest doc no and disabled used option */}
//         <Autocomplete
//           options={filteredReturnDocNoList}
//           loading={returnDocNoLoading}
//           getOptionLabel={(option) => (option.docno ? option.docno : "")}
//           getOptionDisabled={(option) => option.disabled}
//           value={
//             filteredReturnDocNoList.find((opt) => opt.docno === billNo) || null
//           }
//           onChange={(e, value) => {
//             if (data.length === 0) {
//               dispatch(setSnackbar(true, "error", "please sale any one product"));
//             } else if (value?.docno && value.docno !== usedReturnBill) {
//               onReturnBillUsed(value.docno);
//             }
//           }}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               size="small"
//               label="Return bill"
//               fullWidth
//               sx={{ marginBottom: 1.5 }}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter") {
//                   onReturnBillUsed(params.inputProps.value);
//                 }
//               }}
//               InputProps={{
//                 ...params.InputProps,
//                 endAdornment: (
//                   <>
//                     {returnDocNoLoading ? (
//                       <span style={{ marginRight: 8 }}>
//                         <i className="fa fa-spinner fa-spin" />
//                       </span>
//                     ) : null}
//                     {params.InputProps.endAdornment}
//                   </>
//                 ),
//               }}
//             />
//           )}
//           isOptionEqualToValue={(option, value) => option.docno === value.docno}
//         />
//         <Autocomplete
//           options={returnData}
//           multiple={true}
//           disableClearable
//           limitTags={3}
//           size="small"
//           getOptionLabel={(option) => option.barcode}
//           onChange={(e, value) => setReturnBar(value)}
//           isOptionEqualToValue={(option, value) => option.barcode === value.barcode}
//           disabled={returnData.length === 0}
//           sx={{ marginBlock: 1 }}
//           renderInput={(params) => (
//             <TextField {...params} label="Select Barcode" autoComplete="off" />
//           )}
//         />
//       </Grid>
//       <Grid item lg={4}>
//         <TextField
//           size="small"
//           label="Bill No"
//           fullWidth
//           value={docName.replace(/\/(\d+)\/(\d+)\//, "/$1-$2/")}
//           InputProps={{ readOnly: true }}
//         />
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DatePicker
//             onChange={(e) => handleChange(e)}
//             value={dayjs(poDetails.docDate)}
//             label="Bill Date"
//             disabled
//             slotProps={{
//               textField: {
//                 size: "small",
//               },
//             }}
//             sx={{ width: "100%", marginBlock: 1.5 }}
//           />
//         </LocalizationProvider>
//         <Autocomplete
//           id="salesman"
//           name="salesman"
//           size="small"
//           options={salesMan}
//           getOptionLabel={(option) =>
//             `${option.sales_man_name} - ${option.sales_man_code}`
//           }
//           value={poDetails.salesManId}
//           onChange={handleSalesMan}
//           disableClearable
//           isOptionEqualToValue={(option, value) => option.id === value.id}
//           sx={{ marginBlock: 1 }}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               label="Salesman"
//               autoComplete="off"
//               inputRef={salesmanRef}
//             />
//           )}
//         />
//         <Autocomplete
//           size="small"
//           options={socialMediaPlatforms}
//           required
//           disableClearable
//           value={channels}
//           sx={{ marginBlock: 1 }}
//           onChange={(e, value) => {
//             if (points === 0) {
//               setChannels(value);
//             }
//           }}
//           getOptionLabel={(option) => option.fullname}
//           renderInput={(params) => <TextField {...params} label="Select Channels" />}
//           disabled={points > 0}
//         />
//         <Typography
//           sx={{
//             fontWeight: "bold",
//             textAlign: "right",
//             backgroundColor: "#ba68c8",
//             color: "#fff",
//             padding: "8px 20px",
//           }}
//         >
//           {subCatName} Total available Qty is : {count}
//         </Typography>
//       </Grid>
//       <Dialog open={otpOpen} sx={{ width: "800px !important", margin: "0 auto" }}>
//         <Grid
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "10px",
//           }}
//         >
//           <Typography
//             sx={{
//               fontSize: 20,
//               color: "#004AAD",
//               fontWeight: "bold",
//               marginRight: "50px",
//             }}
//           >
//             please enter the OTP for this number
//             <span style={{ fontSize: 20, color: "#000", fontWeight: "bold" }}>
//               {party.mobile}
//             </span>
//           </Typography>
//           <IconButton onClick={() => setOtpOpen(false)}>
//             <Close />
//           </IconButton>
//         </Grid>
//         <Divider />
//         <Grid sx={{ padding: "20px" }}>
//           <OTPInput
//             shouldAutoFocus
//             name="otp"
//             id="otp"
//             containerStyle={classes.otpContainer}
//             inputStyle={classes.otpField}
//             onChange={(otp) => formik.setFieldValue("otp", otp)}
//             numInputs={4}
//             renderInput={(props) => <input {...props} />}
//             value={formik.values.otp}
//             error={formik.touched.otp && Boolean(formik.errors.otp)}
//             helperText={formik.touched.otp && formik.errors.otp}
//           />
//           <Grid sx={{ textAlign: "end" }}>
//             <Button variant="contained" onClick={formik.handleSubmit}>
//               Verify OTP
//             </Button>
//           </Grid>
//         </Grid>
//       </Dialog>
//     </Grid>
//   );
// };

// export default memo(SalesInfo);

//22-09-2025

// import { Close } from "@mui/icons-material";
// import {
//   Autocomplete,
//   Button,
//   Dialog,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axios from "axios";
// import dayjs from "dayjs";
// import { useFormik } from "formik";
// import moment from "moment";
// import React, { memo, useEffect, useRef, useState } from "react";
// import OTPInput from "react-otp-input";
// import { useDispatch } from "react-redux";
// import * as yup from "yup";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { useStyle } from "../style";

// const SalesInfo = ({
//   subCatName,
//   count,
//   setPostData,
//   postData,
//   setReward,
//   thisBill,
//   setDocNameDefault,
//   setThisBill,
//   billPoints,
//   setBillPoints,
//   data,
//   setOp,
//   setDocName,
//   docName,
//   setReturnAmnt,
//   returnAmnt,
//   poDetails,
//   setPoDetails,
//   setEnableRedeem,
//   setMember,
//   selectedMode,
//   setSelectedMode,
//   netTotal,
//   codeRef,
// }) => {
//   const classes = useStyle();
//   const dispatch = useDispatch();
//   const [flag, setFlag] = useState(false);
//   const outlet_id = localStorage.getItem("outlet_id");
//   const [returnData, setReturnData] = useState([]);
//   const [returnBar, setReturnBar] = useState([]);
//   const [salesMan, setSalesMan] = useState([]);
//   const [billNo, setBillNo] = useState("");
//   const nameRef = useRef(null);
//   const [otName, setOtName] = useState("");
//   const [otpToken, setOtpToken] = useState("");
//   const [otpOpen, setOtpOpen] = useState(false);
//   const [otpEnable, setOtpEnable] = useState(false);
//   const [otpDisable, setOtpDisable] = useState(false);
//   // CHANGED: Use 'null' as initial value for channels, not "" or undefined
//   const [channels, setChannels] = useState(null);
//   const mobileRef = useRef(null);
//   const addressRef = useRef(null);
//   const salesmanRef = useRef(null);
//   const [party, setParty] = useState({
//     name: "",
//     mobile: "",
//     address: "",
//     gstin: "",
//   });
//   const [points, setPoints] = useState("");
//   const [returnDocNoList, setReturnDocNoList] = useState([]);
//   const [returnDocNoLoading, setReturnDocNoLoading] = useState(false);
//   const [usedReturnBill, setUsedReturnBill] = useState(null);

//   const validationSchema = yup.object().shape({
//     otp: yup
//       .string("Enter your otp")
//       .matches(/^\d{4}$/, "Enter a valid 4-digit OTP")
//       .required("Please enter your otp here"),
//     name: yup
//       .string()
//       .matches(/^[A-Za-z\s]*$/, "Only letters and spaces are allowed")
//       .test("name-or-mobile-filled", "Customer Name is required*", function (value) {
//         const { mobile } = this.parent;
//         if (!value && !mobile) return true;
//         return !!value;
//       }),
//     mobile: yup
//       .string()
//       .matches(/^\d{10}$/, "Please enter a valid 10-digit mobile number")
//       .test("name-or-mobile-filled", "Mobile number is required*", function (value) {
//         const { name } = this.parent;
//         if (!value && !name) return true;
//         return !!value;
//       }),
//   });

//   const socialMediaPlatforms = [
//     { id: 1, fullname: "Facebook" },
//     { id: 2, fullname: "YouTube" },
//     { id: 3, fullname: "Instagram" },
//     { id: 4, fullname: "Others" },
//     { id: 5, fullname: "New walk in" },
//     { id: 6, fullname: "Regular" },
//   ];

//   function handleOnChange(e) {
//     const { name, value } = e.target;
//     formik.setFieldValue(name, value);
//     if (name === "name") {
//       if (/^[A-Za-z\s]*$/.test(value)) {
//         setParty((prev) => ({ ...prev, name: value }));
//       }
//     } else if (name === "mobile") {
//       if (/^\d{0,10}$/.test(value)) {
//         setParty((prev) => ({ ...prev, mobile: value }));
//       }
//       if (value.length === 10) {
//         setReturnDocNoLoading(true);
//         axios
//           .get(`/v1/return/docno/${outlet_id}/${value}`)
//           .then((res) => {
//             const docnos = res.data || [];
//             if (docnos.length === 0) {
//               setReturnDocNoList([]);
//               setReturnDocNoLoading(false);
//               return;
//             }
//             const maxDate = docnos.reduce(
//               (max, item) => (new Date(item.docdate) > new Date(max) ? item.docdate : max),
//               docnos[0].docdate
//             );
//             const latestDateBills = docnos.filter((d) => d.docdate === maxDate);
//             latestDateBills.sort((a, b) => {
//               const suffixA = parseInt(a.docno.split("_").pop(), 10) || 0;
//               const suffixB = parseInt(b.docno.split("_").pop(), 10) || 0;
//               return suffixB - suffixA;
//             });
//             setReturnDocNoList(latestDateBills.length > 0 ? [latestDateBills[0]] : []);
//             setReturnDocNoLoading(false);
//           })
//           .catch((err) => {
//             setReturnDocNoList([]);
//             setReturnDocNoLoading(false);
//           });
//       } else {
//         setReturnDocNoList([]);
//       }
//       if (value.length < 10) {
//         setParty((prev) => ({ ...prev, name: "", gstin: "", address: "" }));
//         setPoints("");
//         setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
//         setThisBill(0);
//         setOp(false);
//         setEnableRedeem(false);
//         setOtpDisable(false);
//       }
//     } else if (name === "address") {
//       setParty((prev) => ({ ...prev, address: value }));
//     }
//   }

//   function onReturnBillUsed(docno) {
//     setUsedReturnBill(docno);
//     setBillNo(docno);
//     const returnBill = {
//       docno: docno.replace("/", "_").replace("-", "_").replace("/", "_"),
//     };
//     axios
//       .post(`/v1/outlet_sales_return_master/getone`, returnBill)
//       .then((res) => setReturnData(res.data))
//       .catch((err) =>
//         dispatch(setSnackbar(true, "error", err.response?.data?.errors?.[0]?.message || "Error"))
//       );
//   }

//   function enterReturnBill(e) {
//     if (data.length === 0) {
//       dispatch(setSnackbar(true, "error", "please sale any one product"));
//     } else {
//       const value = e.target.value || billNo;
//       onReturnBillUsed(value);
//     }
//   }

//   function fetchMember() {
//     if (postData.mobile.length === 10) {
//       axios
//         .post("v1/fetch_outlet_member", { mobile: party.mobile })
//         .then((res) => {
//           const data = res.data[0];
//           setMember(true);
//           setParty((prev) => ({
//             ...prev,
//             name: data.party_name,
//             gstin: data.gst_in,
//             address: data.address,
//           }));
//           formik.setFieldValue("name", data.party_name || "");
//           const points = parseFloat(data.balance_points);
//           setPoints(points);
//           setBillPoints((prev) => ({
//             ...prev,
//             total: points + parseFloat(thisBill),
//             defaultPoint: points,
//           }));
//           setReward(points);
//           setFlag(true);
//           if (points > 0) {
//             setOtpEnable(true);
//           }
//         })
//         .catch((err) => {
//           const error = err.response?.data?.errors?.[0];
//           const message = error?.message || "";
//           if (error?.code === "NOT_FOUND") {
//             if (message.trim() === "" && mobileRef?.current) {
//               formik.setFieldValue("mobile", "");
//               formik.setFieldValue("name", "");
//               setTimeout(() => {
//                 mobileRef.current.focus();
//               }, 100);
//             }
//             setPoints(0.0);
//             setMember(false);
//             setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
//             setFlag(false);
//             setOtpEnable(false);
//             setOp(false);
//             return;
//           }
//           setParty({
//             mobile: "",
//             name: "",
//             gstin: "",
//             address: "",
//           });
//           setPoints(0.0);
//           setMember(false);
//           setBillPoints({ total: 0, defaultPoint: 0 });
//           setOtpEnable(false);
//           setFlag(false);
//           setOp(false);
//           dispatch(setSnackbar(true, "error", message || "Something went wrong"));
//         });
//     } else {
//       dispatch(setSnackbar(true, "error", "Please enter a 10-digit mobile number"));
//       formik.setFieldValue("mobile", "");
//       setTimeout(() => {
//         mobileRef?.current?.focus();
//       }, 100);
//     }
//   }

//   function handleOtp() {
//     axios
//       .post(`/v1/sendotp`, { mobile: party.mobile })
//       .then((res) => {
//         setOtpToken(res.data.token);
//         setOtpOpen(true);
//       })
//       .catch(() => {});
//   }

//   const handleKeyPress = (event, currentFieldRef, nextFieldRef) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//       if (currentFieldRef === mobileRef) {
//         fetchMember();
//       }
//       if (nextFieldRef && nextFieldRef.current) {
//         nextFieldRef.current.focus();
//       }
//     }
//   };

//   const handleSalesMan = (e, value) => {
//     setPoDetails((prev) => ({ ...prev, salesManId: value }));
//   };

//   const handleModeChange = (event) => {
//     const mode = event.target.value;
//     setSelectedMode(mode);
//     modeCheck(mode);
//   };

//   const handleChange = (e) => {
//     setPoDetails((prevState) => ({ ...prevState, docDate: dayjs(e).format() }));
//   };

//   function modeCheck(mode) {
//     const baseAmount = returnAmnt ? postData.amount - returnAmnt : postData.amount;
//     let adjustedAmount;
//     if (postData.loyalty_redem) {
//       adjustedAmount = baseAmount - postData.loyalty_redem;
//     } else {
//       adjustedAmount = baseAmount;
//     }
//     adjustedAmount -= postData.less_amount || 0;
//     const finalAmount = adjustedAmount < 0 ? `-${Math.abs(adjustedAmount)}` : adjustedAmount;
//     if (mode === "cash") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: "0",
//         cash_amount: finalAmount,
//         upi_amount: "0",
//       }));
//     } else if (mode === "card") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: finalAmount,
//         cash_amount: "0",
//         upi_amount: "0",
//       }));
//     } else if (mode === "upi") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: "0",
//         cash_amount: "0",
//         upi_amount: finalAmount,
//       }));
//     }
//   }

//   function getSalesMan() {
//     axios
//       .get(`v1/SalesMan/outlets/${outlet_id}`)
//       .then((res) => setSalesMan(res.data))
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }

//   useEffect(() => {
//     getSalesMan();
//     axios
//       .get(`/v1/outlet_sales_master/${outlet_id}`)
//       .then((res) => {
//         let input = res.data.Docno;
//         setDocNameDefault(input);
//         let output = input.replace(/_/g, "/").replace(/(\d+)_(\d+)_(\d+)/, "$1-$2/$3");
//         setDocName(output);
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }, []);

//   useEffect(() => {
//     if (returnBar.length > 0) {
//       let return_amt = returnBar.reduce((acc, item) => acc + parseFloat(item.mrp), 0);
//       setReturnAmnt(return_amt);
//     } else {
//       setReturnAmnt(0);
//     }
//   }, [returnBar]);

//   useEffect(() => {
//     if (returnBar.length > 0) {
//       let return_amt = returnBar.reduce((acc, item) => acc + parseFloat(item.mrp), 0);
//       setReturnAmnt(return_amt);
//       modeCheck(selectedMode, return_amt);
//     } else {
//       setReturnAmnt(0);
//       modeCheck(selectedMode, 0);
//     }
//   }, [returnBar, selectedMode]);

//   useEffect(() => {
//     axios(`/v1/outlet/info/${outlet_id}`)
//       .then((res) => {
//         setOtName(res.data.outlet_type_name);
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
//       });
//   }, [outlet_id]);

//   const defaultChannel = socialMediaPlatforms.find((opt) => opt.fullname === "Regular");

//   // CHANGED: Prefill channels to "Regular" when points > 0; clear to null otherwise (not '')
//   useEffect(() => {
//     if (points > 0) {
//       if (channels?.fullname !== "Regular") {
//         setChannels(defaultChannel);
//       }
//     } else {
//       if (channels !== null) {
//         setChannels(null);
//       }
//     }
//   }, [points]);

//   useEffect(() => {
//     setPostData((prev) => ({
//       ...prev,
//       docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
//       mode: selectedMode,
//       party_name: party.name,
//       address: party.address,
//       mobile: party.mobile,
//       return_billno: billNo,
//       return_amount: returnAmnt,
//       channels: channels?.fullname || "",
//     }));
//     modeCheck(selectedMode);
//     if (poDetails.salesManId !== null) {
//       setPostData((prev) => ({
//         ...prev,
//         salesman_id: poDetails.salesManId.id,
//       }));
//     }
//   }, [poDetails, party, selectedMode, returnAmnt, billNo, channels]);

//   useEffect(() => {
//     if (data.length > 0 && party.mobile !== "" && points === "") {
//       fetchMember();
//     }
//   }, [data]);

//   const onOtpSubmit = () => {
//     const config = {
//       headers: {
//         Authorization: `Bearer ${otpToken}`,
//       },
//     };
//     axios
//       .post(`/v1/verifyotp`, { otp: formik.values.otp }, config)
//       .then((res) => {
//         if (res.data.success) {
//           dispatch(setSnackbar(true, "success", res.data.message));
//           setOtpOpen(false);
//           setOp(true);
//           setEnableRedeem(true);
//           setOtpDisable(true);
//         } else {
//           dispatch(setSnackbar(true, "error", res.data.message));
//         }
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.data.message));
//         setOtpOpen(false);
//         formik.resetForm();
//       });
//   };

//   const formik = useFormik({
//     initialValues: {
//       otp: "",
//       name: "",
//       mobile: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: onOtpSubmit,
//   });

//   const filteredReturnDocNoList = returnDocNoList.map((option) => ({
//     ...option,
//     disabled: usedReturnBill === option.docno,
//   }));

//   return (
//     <Grid container spacing={2} className="p-2 h-full">
//       <Grid item lg={4}>
//         <TextField
//           autoComplete="off"
//           inputRef={mobileRef}
//           size="small"
//           label="Mobile"
//           fullWidth
//           name="mobile"
//           value={formik.values.mobile}
//           onChange={handleOnChange}
//           onKeyDown={(e) => handleKeyPress(e, mobileRef, nameRef)}
//           onBlur={formik.handleBlur}
//           error={formik.touched.mobile && !!formik.errors.mobile && formik.values.mobile !== ""}
//           helperText={formik.touched.mobile && formik.values.mobile !== "" && formik.errors.mobile}
//         />
//         <TextField
//           sx={{ marginBlock: 1.5 }}
//           inputRef={nameRef}
//           size="small"
//           label="Customer Name"
//           fullWidth
//           name="name"
//           value={formik.values.name}
//           onChange={handleOnChange}
//           disabled={flag}
//           onKeyDown={(e) => handleKeyPress(e, nameRef, addressRef)}
//           onBlur={formik.handleBlur}
//           error={formik.touched.name && Boolean(formik.errors.name) && formik.values.mobile !== ""}
//           helperText={
//             formik.touched.name && formik.errors.name && formik.values.mobile !== ""
//               ? formik.errors.name
//               : ""
//           }
//         />
//         <TextField
//           inputRef={addressRef}
//           size="small"
//           label="Address"
//           fullWidth
//           name="address"
//           multiline
//           sx={{ marginBottom: 1.5 }}
//           value={party.address}
//           onChange={handleOnChange}
//           disabled={flag}
//           onKeyDown={(e) => handleKeyPress(e, addressRef, salesmanRef)}
//         />
//         <div className="flex">
//           <TextField
//             size="small"
//             label="Points"
//             name="points"
//             value={points}
//             InputProps={{ readOnly: true }}
//             disabled={!flag}
//             sx={{ marginInline: 0.5 }}
//           />
//           <TextField
//             size="small"
//             label="This Bill"
//             name="billPoints"
//             value={parseFloat(thisBill).toFixed(0)}
//             InputProps={{ readOnly: true }}
//             disabled={!flag}
//             sx={{ marginInline: 0.5 }}
//           />
//           <TextField
//             size="small"
//             label="Total"
//             name="Total"
//             value={parseFloat(billPoints.total).toFixed(0)}
//             InputProps={{ readOnly: true }}
//             disabled={!flag}
//             sx={{ marginInline: 0.5 }}
//           />
//         </div>
//         {otpEnable && party.mobile !== "" && (
//           <Button
//             onClick={handleOtp}
//             variant={otpDisable ? "" : "contained"}
//             disabled={otpDisable}
//             sx={{ marginBlock: "10px" }}
//           >
//             Send Otp for redeem points
//           </Button>
//         )}
//       </Grid>
//       <Grid item lg={4}>
//         {otName !== "OWN" && (
//           <TextField
//             size="small"
//             label="GSTIN"
//             fullWidth
//             name="gstin"
//             value={party.gstin}
//             onChange={handleOnChange}
//           />
//         )}
//         <Typography variant="body1">Mode</Typography>
//         <FormControl sx={{ display: "flex" }}>
//           <RadioGroup
//             aria-labelledby="demo-radio-buttons-group-label"
//             name="mode"
//             id="mode"
//             sx={{ flexDirection: "row", display: "flex" }}
//             value={selectedMode}
//             onChange={handleModeChange}
//           >
//             <FormControlLabel value="cash" control={<Radio size="small" />} label="Cash" />
//             <FormControlLabel value="card" control={<Radio size="small" />} label="Card" />
//             <FormControlLabel value="upi" control={<Radio size="small" />} label="UPI" />
//             <FormControlLabel value="mixed" control={<Radio size="small" />} label="Mixed Pay" />
//           </RadioGroup>
//         </FormControl>
//         <Autocomplete
//           options={filteredReturnDocNoList}
//           loading={returnDocNoLoading}
//           getOptionLabel={(option) => (option.docno ? option.docno : "")}
//           getOptionDisabled={(option) => option.disabled}
//           value={filteredReturnDocNoList.find((opt) => opt.docno === billNo) || null}
//           onChange={(e, value) => {
//             if (data.length === 0) {
//               dispatch(setSnackbar(true, "error", "please sale any one product"));
//             } else if (value?.docno && value.docno !== usedReturnBill) {
//               onReturnBillUsed(value.docno);
//             }
//           }}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               size="small"
//               label="Return bill"
//               fullWidth
//               sx={{ marginBottom: 1.5 }}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter") {
//                   onReturnBillUsed(params.inputProps.value);
//                 }
//               }}
//               InputProps={{
//                 ...params.InputProps,
//                 endAdornment: (
//                   <>
//                     {returnDocNoLoading ? (
//                       <span style={{ marginRight: 8 }}>
//                         <i className="fa fa-spinner fa-spin" />
//                       </span>
//                     ) : null}
//                     {params.InputProps.endAdornment}
//                   </>
//                 ),
//               }}
//             />
//           )}
//           isOptionEqualToValue={(option, value) => option.docno === value.docno}
//         />
//         <Autocomplete
//           options={returnData}
//           multiple={true}
//           disableClearable
//           limitTags={3}
//           size="small"
//           getOptionLabel={(option) => option.barcode}
//           onChange={(e, value) => setReturnBar(value)}
//           isOptionEqualToValue={(option, value) => option.barcode === value.barcode}
//           disabled={returnData.length === 0}
//           sx={{ marginBlock: 1 }}
//           renderInput={(params) => <TextField {...params} label="Select Barcode" autoComplete="off" />}
//         />
//             <TextField
//              size="small"
//              label="Referral Number"
//               fullWidth
//               name="referral_number"
//                 sx={{ marginBottom: 1.5 }}
//                 value={postData.referral_number || ""}
//                  onChange={(e) =>setPostData((prev) => ({...prev,
//       referral_number: e.target.value,
//     }))
//   }
//   disabled={channels?.fullname?.toLowerCase() === "regular"}
// />

//       </Grid>
//       <Grid item lg={4}>
//         <TextField
//           size="small"
//           label="Bill No"
//           fullWidth
//           value={docName.replace(/\/(\d+)\/(\d+)\//, "/$1-$2/")}
//           InputProps={{ readOnly: true }}
//         />
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DatePicker
//             onChange={(e) => handleChange(e)}
//             value={dayjs(poDetails.docDate)}
//             label="Bill Date"
//             disabled
//             slotProps={{
//               textField: {
//                 size: "small",
//               },
//             }}
//             sx={{ width: "100%", marginBlock: 1.5 }}
//           />
//         </LocalizationProvider>
//         <Autocomplete
//           id="salesman"
//           name="salesman"
//           size="small"
//           options={salesMan}
//           getOptionLabel={(option) => `${option.sales_man_name} - ${option.sales_man_code}`}
//           value={poDetails.salesManId}
//           onChange={handleSalesMan}
//           disableClearable
//           isOptionEqualToValue={(option, value) => option.id === value.id}
//           sx={{ marginBlock: 1 }}
//           renderInput={(params) => (
//             <TextField {...params} label="Salesman" autoComplete="off" inputRef={salesmanRef} />
//           )}
//         />
//         {/* CHANGED: CHANNELS Autocomplete - Proper default and null handling */}
//         <Autocomplete
//           size="small"
//           options={socialMediaPlatforms}
//           required
//           disableClearable
//           value={channels}
//           sx={{ marginBlock: 1 }}
//           onChange={(e, value) => {
//             setChannels(value);
//           }}
//           getOptionLabel={(option) => option.fullname || ""}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               label="Select Channels"
//               // CHANGED: show "Please select channel" when no channel selected
//               placeholder={channels === null ? "Please select channel" : ""}
//               InputProps={{
//                 ...params.InputProps,
//                 value: channels?.fullname || "",
//               }}
//             />
//           )}
//           disabled={points > 0}
//         />
//         <Typography
//           sx={{
//             fontWeight: "bold",
//             textAlign: "right",
//             backgroundColor: "#ba68c8",
//             color: "#fff",
//             padding: "8px 20px",
//           }}
//         >
//           {subCatName} Total available Qty is : {count}
//         </Typography>
//       </Grid>
//       <Dialog open={otpOpen} sx={{ width: "800px !important", margin: "0 auto" }}>
//         <Grid
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "10px",
//           }}
//         >
//           <Typography
//             sx={{
//               fontSize: 20,
//               color: "#004AAD",
//               fontWeight: "bold",
//               marginRight: "50px",
//             }}
//           >
//             please enter the OTP for this number
//             <span style={{ fontSize: 20, color: "#000", fontWeight: "bold" }}>{party.mobile}</span>
//           </Typography>
//           <IconButton onClick={() => setOtpOpen(false)}>
//             <Close />
//           </IconButton>
//         </Grid>
//         <Divider />
//         <Grid sx={{ padding: "20px" }}>
//           <OTPInput
//             shouldAutoFocus
//             name="otp"
//             id="otp"
//             containerStyle={classes.otpContainer}
//             inputStyle={classes.otpField}
//             onChange={(otp) => formik.setFieldValue("otp", otp)}
//             numInputs={4}
//             renderInput={(props) => <input {...props} />}
//             value={formik.values.otp}
//             error={formik.touched.otp && Boolean(formik.errors.otp)}
//             helperText={formik.touched.otp && formik.errors.otp}
//           />
//           <Grid sx={{ textAlign: "end" }}>
//             <Button variant="contained" onClick={formik.handleSubmit}>
//               Verify OTP
//             </Button>
//           </Grid>
//         </Grid>
//       </Dialog>
//     </Grid>
//   );
// };

// export default memo(SalesInfo);

//testing referral program

import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Paper,
} from "@mui/material";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import dayjs from "dayjs";
import { useFormik } from "formik";
import moment from "moment";
import React, { memo, useEffect, useRef, useState } from "react";
import OTPInput from "react-otp-input";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../style";

const SalesInfo = ({
  subCatName,
  count,
  setPostData,
  postData,
  setReward,
  thisBill,
  setDocNameDefault,
  setThisBill,
  billPoints,
  setBillPoints,
  data,
  setOp,
  setDocName,
  docName,
  setReturnAmnt,
  returnAmnt,
  poDetails,
  setPoDetails,
  setEnableRedeem,
  setMember,
  selectedMode,
  setSelectedMode,
  netTotal,
  codeRef,
  setCurrentTempId,
  onLoadPending,
  onPendingDeleted,
}) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [flag, setFlag] = useState(false);
  const outlet_id = localStorage.getItem("outlet_id");
  const outletid = localStorage.getItem("outletid");
  const [returnData, setReturnData] = useState([]);
  const [returnBar, setReturnBar] = useState([]);
  const [salesMan, setSalesMan] = useState([]);
  const [billNo, setBillNo] = useState("");
  const nameRef = useRef(null);
  const [otName, setOtName] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const [otpOpen, setOtpOpen] = useState(false);
  const [otpEnable, setOtpEnable] = useState(false);
  const [otpDisable, setOtpDisable] = useState(false);
  // CHANGED: Use 'null' as initial value for channels, not "" or undefined
  const [channels, setChannels] = useState(null);
  const mobileRef = useRef(null);
  const addressRef = useRef(null);
  const salesmanRef = useRef(null);
  const [party, setParty] = useState({
    name: "",
    mobile: "",
    address: "",
    gstin: "",
  });
  const [points, setPoints] = useState("");
  const [slipNo, setSlipNo] = useState("");
  const [returnDocNoList, setReturnDocNoList] = useState([]);
  const [returnDocNoLoading, setReturnDocNoLoading] = useState(false);
  const [usedReturnBill, setUsedReturnBill] = useState(null);
  // const [referrerMobile, setReferrerMobile] = useState("");
  const [refereeMobile, setRefereeMobile] = useState("");
  const [refereeName, setRefereeName] = useState("");
  // const [referrerError, setReferrerError] = useState("");
  const [refereeError, setRefereeError] = useState("");
  const [showPendingBills, setShowPendingBills] = useState(false);
  const [pendingBills, setPendingBills] = useState([]);
  const [pendingLoading, setPendingLoading] = useState(false);
  const [referralInfo, setReferralInfo] = useState(null);
  const debounceRef = useRef(null);

  const removePendingBillFromList = (deletedTempId) => {
    setPendingBills((prev) => prev.filter((bill) => bill.id !== deletedTempId));
  };

  // ✅ Referrer mobile validation (CORRECTED)
  // const validateReferrerLocal = (value) => {
  //   if (!value) {
  //     setReferrerError("");
  //     return;
  //   }

  //   if (!/^\d{10}$/.test(value)) {
  //     setReferrerError("Enter valid 10-digit mobile");
  //     return;
  //   }

  //   // ✅ Use party.mobile (NOT postData.mobile)
  //   if (party.mobile && value === party.mobile) {
  //     setReferrerError("Referrer and customer cannot be same");
  //     return;
  //   }

  //   setReferrerError("");
  // };
  const validateRefereeLocal = (value) => {
    if (!value) {
      setRefereeError("");
      return;
    }

    if (!/^\d{10}$/.test(value)) {
      setRefereeError("Enter valid 10-digit mobile");
      return;
    }

    if (party.mobile && value === party.mobile) {
      setRefereeError("Referee and customer cannot be same");
      return;
    }

    setRefereeError("");
  };
  // const handleReferrerChange = (e) => {
  const handleRefereeChange = async (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length > 10) return;

    // setReferrerMobile(value);
    setRefereeMobile(value);
    // validateReferrerLocal(value);
    validateRefereeLocal(value);
    if (value.length === 10) {
      try {
        const res = await axios.post("v1/check_referral", {
          mobile: value,
          outletid: outlet_id,
        });

        // 🔥 SHOW ERROR HERE
        // if (res.data.isExistingCustomer) {
        //   setRefereeError("Already existing customer");
        //   return;
        // }

        // // optional: clear error if valid
        // setRefereeError("");
        if (res.data.message) {
          dispatch(setSnackbar(true, "error", res.data.message));
          // setRefereeError(res.data.message);
          setRefereeMobile("");
        } else {
          setRefereeError("");
        }
      } catch (err) {
        console.log("Error checking referee", err);
      }
    }
  };
  const handleRefereeNameChange = (e) => {
    const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");

    setRefereeName(value);
  };

  const validationSchema = yup.object().shape({
    // slipNo: yup.string().required("S.No is required*"),
    slipNo: yup
      .string()
      .matches(/^[0-9]*$/, "Only numbers allowed"),
      // .required("S.No is required*"),
    otp: yup
      .string("Enter your otp")
      .matches(/^\d{4}$/, "Enter a valid 4-digit OTP")
      .required("Please enter your otp here"),
    name: yup
      .string()
      .matches(/^[A-Za-z\s]*$/, "Only letters and spaces are allowed")
      .test(
        "name-or-mobile-filled",
        "Customer Name is required*",
        function (value) {
          const { mobile } = this.parent;
          if (!value && !mobile) return true;
          return !!value;
        },
      ),
    mobile: yup
      .string()
      .matches(/^\d{10}$/, "Please enter a valid 10-digit mobile number")
      .test(
        "name-or-mobile-filled",
        "Mobile number is required*",
        function (value) {
          const { name } = this.parent;
          if (!value && !name) return true;
          return !!value;
        },
      ),
  });

  const socialMediaPlatforms = [
    { id: 1, fullname: "Facebook" },
    { id: 2, fullname: "YouTube" },
    { id: 3, fullname: "Instagram" },
    { id: 4, fullname: "Others" },
    { id: 5, fullname: "New walk in" },
    { id: 6, fullname: "Regular" },
  ];

  function handleOnChange(e) {
    const { name, value } = e.target;
    formik.setFieldValue(name, value);
    // if (name === "slipNo") {
    //   setSlipNo(value);
    // }

    if (name === "slipNo") {
  const numericValue = value.replace(/\D/g, "");
  formik.setFieldValue("slipNo", numericValue);

  setSlipNo(numericValue);

  setPostData((prev) => ({
    ...prev,
    s_no: numericValue,
  }));

  if (!numericValue) {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    return;
  }

  if (debounceRef.current) {
    clearTimeout(debounceRef.current);
  }

  debounceRef.current = setTimeout(() => {
    handleCheckDuplicateSno(numericValue);
  }, 600);

  return;
}

    if (name === "name") {
      if (/^[A-Za-z\s]*$/.test(value)) {
        setParty((prev) => ({ ...prev, name: value }));
      }
    } else if (name === "mobile") {
      setRefereeMobile("");
      setRefereeError("");
      if (/^\d{0,10}$/.test(value)) {
        setParty((prev) => ({ ...prev, mobile: value }));
      }
      if (value.length === 10) {
        setReturnDocNoLoading(true);
        axios
          .get(`/v1/return/docno/${outlet_id}/${value}`)
          .then((res) => {
            const docnos = res.data || [];
            if (docnos.length === 0) {
              setReturnDocNoList([]);
              setReturnDocNoLoading(false);
              return;
            }
            const maxDate = docnos.reduce(
              (max, item) =>
                new Date(item.docdate) > new Date(max) ? item.docdate : max,
              docnos[0].docdate,
            );
            const latestDateBills = docnos.filter((d) => d.docdate === maxDate);
            latestDateBills.sort((a, b) => {
              const suffixA = parseInt(a.docno.split("_").pop(), 10) || 0;
              const suffixB = parseInt(b.docno.split("_").pop(), 10) || 0;
              return suffixB - suffixA;
            });
            setReturnDocNoList(
              latestDateBills.length > 0 ? [latestDateBills[0]] : [],
            );
            setReturnDocNoLoading(false);
          })
          .catch((err) => {
            setReturnDocNoList([]);
            setReturnDocNoLoading(false);
          });
      } else {
        setReturnDocNoList([]);
      }
      // if (value.length < 10) {
      //   setParty((prev) => ({ ...prev, name: "", gstin: "", address: "" }));
      //   setPoints("");
      //   setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
      //   setThisBill(0);
      //   setOp(false);
      //   setEnableRedeem(false);
      //   setOtpDisable(false);
      // }
      if (value.length === 0) {
        setParty((prev) => ({ ...prev, name: "", gstin: "", address: "" }));
        setPoints("");
        setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
        setThisBill(0);
        setOp(false);
        setEnableRedeem(false);
        setOtpDisable(false);
      }
    } else if (name === "address") {
      setParty((prev) => ({ ...prev, address: value }));
    }
  }

  function onReturnBillUsed(docno) {
    setUsedReturnBill(docno);
    setBillNo(docno);
    const returnBill = {
      docno: docno.replace("/", "_").replace("-", "_").replace("/", "_"),
    };
    axios
      .post(`/v1/outlet_sales_return_master/getone`, returnBill)
      .then((res) => setReturnData(res.data))
      .catch((err) =>
        dispatch(
          setSnackbar(
            true,
            "error",
            err.response?.data?.errors?.[0]?.message || "Error",
          ),
        ),
      );
  }

  function enterReturnBill(e) {
    if (data.length === 0) {
      dispatch(setSnackbar(true, "error", "please sale any one product"));
    } else {
      const value = e.target.value || billNo;
      onReturnBillUsed(value);
    }
  }

  function fetchMember() {
    if (flag) return;
    if (postData.mobile.length === 10) {
      axios
        .post("v1/fetch_outlet_member", { mobile: party.mobile })
        .then((res) => {
          const data = res.data[0];
          setPostData((prev) => ({
            ...prev,
            is_referral_customer: data.is_referral_customer,
          }));
          setMember(true);
          setParty((prev) => ({
            ...prev,
            name: data.party_name,
            gstin: data.gst_in,
            address: data.address,
          }));
          formik.setFieldValue("name", data.party_name || "");
          const points = parseFloat(data.balance_points);
          setPoints(points);
          setBillPoints((prev) => ({
            ...prev,
            total: points + parseFloat(thisBill),
            defaultPoint: points,
          }));
          setReward(points);
          setFlag(true);
          if (points > 0) {
            setOtpEnable(true);
          }
        })
        .catch((err) => {
          const error = err.response?.data?.errors?.[0];
          const message = error?.message || "";
          setFlag(true);
          if (error?.code === "NOT_FOUND") {
            if (message.trim() === "" && mobileRef?.current) {
              formik.setFieldValue("mobile", "");
              formik.setFieldValue("name", "");
              setTimeout(() => {
                mobileRef.current.focus();
              }, 100);
            }
            setPoints(0.0);
            setMember(false);
            setBillPoints((prev) => ({ ...prev, total: 0, defaultPoint: 0 }));
            setFlag(false);
            setOtpEnable(false);
            setOp(false);
            return;
          }
          setParty({
            mobile: "",
            name: "",
            gstin: "",
            address: "",
          });
          setPoints(0.0);
          setMember(false);
          setBillPoints({ total: 0, defaultPoint: 0 });
          setOtpEnable(false);
          setFlag(false);
          setOp(false);
          dispatch(
            setSnackbar(true, "error", message || "Something went wrong"),
          );
        });
    } else {
      dispatch(
        setSnackbar(true, "error", "Please enter a 10-digit mobile number"),
      );
      formik.setFieldValue("mobile", "");
      setTimeout(() => {
        mobileRef?.current?.focus();
      }, 100);
    }
  }

  function handleOtp() {
    axios
      .post(`/v1/sendotp`, { mobile: party.mobile })
      .then((res) => {
        setOtpToken(res.data.token);
        setOtpOpen(true);
      })
      .catch(() => {});
  }

  const handleKeyPress = (event, currentFieldRef, nextFieldRef) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (currentFieldRef === mobileRef) {
        fetchMember();
      }
      if (nextFieldRef && nextFieldRef.current) {
        nextFieldRef.current.focus();
      }
    }
  };

  const handleSalesMan = (e, value) => {
    setPoDetails((prev) => ({ ...prev, salesManId: value }));
  };

  const handleModeChange = (event) => {
    const mode = event.target.value;
    setSelectedMode(mode);
    modeCheck(mode);
  };

  const handleChange = (e) => {
    setPoDetails((prevState) => ({ ...prevState, docDate: dayjs(e).format() }));
  };

  function modeCheck(mode) {
    // const baseAmount = returnAmnt
    //   ? postData.amount - returnAmnt
    //   : postData.amount;
    const baseAmount = Math.max(0, Number(netTotal) || 0);
    let adjustedAmount;
    if (postData.loyalty_redem) {
      adjustedAmount = baseAmount - postData.loyalty_redem;
    } else {
      adjustedAmount = baseAmount;
    }
    adjustedAmount -= postData.less_amount || 0;
    // const finalAmount =
    //   adjustedAmount < 0 ? `-${Math.abs(adjustedAmount)}` : adjustedAmount;
    // const finalAmount = Math.max(0, Number(adjustedAmount) || 0);
    const finalAmount = adjustedAmount < 0 ? 0 : Number(adjustedAmount || 0);
    if (mode === "cash") {
      setPostData((prev) => ({
        ...prev,
        card_amount: "0",
        cash_amount: finalAmount,
        upi_amount: "0",
      }));
    } else if (mode === "card") {
      setPostData((prev) => ({
        ...prev,
        card_amount: finalAmount,
        cash_amount: "0",
        upi_amount: "0",
      }));
    } else if (mode === "upi") {
      setPostData((prev) => ({
        ...prev,
        card_amount: "0",
        cash_amount: "0",
        upi_amount: finalAmount,
      }));
    }
  }

  function getSalesMan() {
    axios
      .get(`v1/SalesMan/outlets/${outlet_id}`)
      .then((res) => setSalesMan(res.data))
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  // const handleOpenPendingBills = () => {
  //   setShowPendingBills(true);
  //   setPendingLoading(true);

  //   axios
  //     .get(`/v1/outlet_sales_temp/1/${outlet_id}`) // company_id = 1
  //     .then((res) => {
  //       setPendingBills(res.data.data || []);
  //     })
  //     .catch((err) => {
  //       dispatch(
  //         setSnackbar(
  //           true,
  //           "error",
  //           err.response?.data?.errors?.[0]?.message ||
  //             "Failed to load pending bills"
  //         )
  //       );
  //     })
  //     .finally(() => setPendingLoading(false));
  // };
  const handleOpenPendingBills = () => {
    setShowPendingBills(true);
    setPendingLoading(true);

    axios
      .get(`v1/outlet_sales_pending_bill/get_all/1/${outlet_id}`)
      .then((res) => {
        const list = res.data.data || res.data;
        setPendingBills(list);
        // ✅ STEP 1: SAVE pending bill count
        setPostData((prev) => ({
          ...prev,
          bill_pending_count: list.length + 1,
        }));
        // setPendingBills(res.data.data || res.data);
      })
      .catch((err) => {
        dispatch(
          setSnackbar(
            true,
            "error",
            err.response?.data?.errors?.[0]?.message ||
              "Failed to load pending bills",
          ),
        );
      })
      .finally(() => setPendingLoading(false));
  };

  const handleCheckReferral = (mobile) => {
    if (!mobile || mobile.length !== 10) return;

    axios
      .post(`v1/check_referral`, {
        mobile,
        outletid: outlet_id,
      })
      .then((res) => {
        const data = res.data;

        if (data.referred) {
          setReferralInfo(data);

          const name = data.referrer_name || "Customer";

          dispatch(
            setSnackbar(
              true,
              "info",
              `Referred by ${name} ${data.referrer_mobile}`,
            ),
          );
        }
      })
      .catch((err) => {
        console.log("Referral check skipped", err);
      });
  };

  const handleCheckDuplicateSno = async (s_no) => {
    if (!s_no || s_no.trim() === "") return;

    try {
      const res = await axios.post("v1/check_duplicate_sno", {
        outletid: outlet_id,
        s_no: s_no,
      });

      if (res.data.isDuplicate) {
        dispatch(setSnackbar(true, "error", res.data.message));

        // ❗ CLEAR FIELD (IMPORTANT)
        setSlipNo("");
        setPostData((prev) => ({
          ...prev,
          s_no: "",
        }));

        return true; // duplicate
      }

      return false; // not duplicate
    } catch (err) {
      console.log("Duplicate check error", err);
      return false;
    }
  };

  useEffect(() => {
    getSalesMan();
    axios
      .get(`/v1/outlet_sales_master/${outlet_id}`)
      .then((res) => {
        let input = res.data.Docno;
        setDocNameDefault(input);
        let output = input
          .replace(/_/g, "/")
          .replace(/(\d+)_(\d+)_(\d+)/, "$1-$2/$3");
        setDocName(output);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
    console.log("useeffect line 3019");
  }, []);

  useEffect(() => {
    if (returnBar.length > 0) {
      let return_amt = returnBar.reduce(
        (acc, item) => acc + parseFloat(item.mrp),
        0,
      );
      setReturnAmnt(return_amt);
    } else {
      setReturnAmnt(0);
    }
    console.log("useeffect line 3037");
  }, [returnBar]);

  useEffect(() => {
    if (returnBar.length > 0) {
      let return_amt = returnBar.reduce(
        (acc, item) => acc + parseFloat(item.mrp),
        0,
      );
      setReturnAmnt(return_amt);
      // modeCheck(selectedMode, return_amt);
    } else {
      setReturnAmnt(0);
      // modeCheck(selectedMode, 0);
    }
    console.log("useeffect line 3050");
  }, [returnBar, selectedMode]);

  useEffect(() => {
    axios(`/v1/outlet/info/${outlet_id}`)
      .then((res) => {
        setOtName(res.data.outlet_type_name);
      })
      .catch((err) => {
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message),
        );
      });
    console.log("useeffect line 3065");
  }, [outlet_id]);

  const defaultChannel = socialMediaPlatforms.find(
    (opt) => opt.fullname === "Regular",
  );

  // CHANGED: Prefill channels to "Regular" when points > 0; clear to null otherwise (not '')
  // useEffect(() => {
  //   if (points > 0) {
  //     if (channels?.fullname !== "Regular") {
  //       setChannels(defaultChannel);
  //     }
  //   } else {
  //     if (channels !== null) {
  //       setChannels(null);
  //     }
  //   }
  //   console.log("useeffect line 3083");
  // }, [points]);
  // 25-03-2026
  useEffect(() => {
    if (postData.is_referral_customer) return; // ✅ ADD THIS LINE

    if (points > 0) {
      if (channels?.fullname !== "Regular") {
        setChannels(defaultChannel);
      }
    } else {
      setChannels(null);
    }
  }, [points, postData.is_referral_customer]);

  // useEffect(() => {
  //   setPostData((prev) => ({
  //     ...prev,
  //     docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
  //     mode: selectedMode,
  //     party_name: party.name,
  //     address: party.address,
  //     mobile: party.mobile,
  //     return_billno: billNo,
  //     return_amount: returnAmnt,
  //     channels: channels?.fullname || "",
  //   }));
  //   modeCheck(selectedMode);
  //   if (poDetails.salesManId !== null) {
  //     setPostData((prev) => ({
  //       ...prev,
  //       salesman_id: poDetails.salesManId.id,
  //     }));
  //   }
  // }, [poDetails, party, selectedMode, returnAmnt, billNo, channels]);
  useEffect(() => {
    setPostData((prev) => ({
      ...prev,
      docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
      mode: selectedMode,
      party_name: party.name,
      address: party.address,
      mobile: party.mobile,
      return_billno: billNo,
      return_amount: returnAmnt,
      channels: channels?.fullname || "",
      salesman_id: poDetails.salesManId?.id || "",
    }));
    console.log("useeffect line 3116");
  }, [
    poDetails.docDate,
    selectedMode,
    party.name,
    party.address,
    party.mobile,
    billNo,
    returnAmnt,
    channels?.fullname,
    poDetails.salesManId?.id,
  ]);

  // useEffect(() => {
  //   if (data.length > 0 && party.mobile !== "" && points === "") {
  //     fetchMember();
  //   }
  // }, [data]);
  useEffect(() => {
    if (
      data.length > 0 &&
      party.mobile.length === 10 &&
      points === "" &&
      !flag
    ) {
      fetchMember();
    }
    console.log("useeffect line 3146");
    // }, [data, party.mobile, points, flag]);
  }, [data, flag]);
  useEffect(() => {
    if (party.mobile.length === 0) {
      // Minimal reset - only customer fields
      formik.setFieldValue("name", "");
      setParty((prev) => ({ ...prev, name: "", address: "", gstin: "" }));
      setPoints(0);
      setMember(false);
      setFlag(false);
    }
  }, [party.mobile.length]); // Triggers only on length change

  useEffect(() => {
    setPostData((prev) => ({
      ...prev,
      // referrer_mobile: referrerMobile || null,
      referee_mobile: refereeMobile || null,
    }));
    console.log("useeffect line 3158");
  }, [refereeMobile]);
  useEffect(() => {
    setPostData((prev) => ({
      ...prev,
      referee_name: refereeName || "",
    }));
  }, [refereeName]);

  useEffect(() => {
    setPostData((prev) => ({
      ...prev,
      s_no: slipNo || "",
    }));
  }, [slipNo]);

  const onOtpSubmit = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${otpToken}`,
      },
    };
    axios
      .post(`/v1/verifyotp`, { otp: formik.values.otp }, config)
      .then((res) => {
        if (res.data.success) {
          dispatch(setSnackbar(true, "success", res.data.message));
          setOtpOpen(false);
          setOp(true);
          setEnableRedeem(true);
          setOtpDisable(true);
        } else {
          dispatch(setSnackbar(true, "error", res.data.message));
        }
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.data.message));
        setOtpOpen(false);
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues: {
      otp: "",
      name: "",
      mobile: "",
      slipNo: "",
    },
    validationSchema: validationSchema,
    onSubmit: onOtpSubmit,
  });

  const filteredReturnDocNoList = returnDocNoList.map((option) => ({
    ...option,
    disabled: usedReturnBill === option.docno,
  }));

  //   useEffect(() => {
  //   if (!postData.mobile && !postData.party_name) return;

  //   // fill customer inputs
  //   setParty((prev) => ({
  //     ...prev,
  //     name: postData.party_name || "",
  //     mobile: postData.mobile || "",
  //     address: postData.address || "",
  //     gstin: postData.gst_in || "",
  //   }));

  //   // loyalty / points
  //   setPoints(postData.balance_points || 0);
  //   setBillPoints((prev) => ({
  //     ...prev,
  //     total: postData.balance_points || 0,
  //     defaultPoint: postData.loyalty_earned || 0,
  //   }));
  //   setThisBill(postData.loyalty_earned || 0);

  //   // mode and channels
  //   setSelectedMode(postData.mode?.toLowerCase() || "cash");
  //   if (postData.channels) {
  //     const matched = socialMediaPlatforms.find(
  //       (c) => c.fullname === postData.channels
  //     );
  //     if (matched) setChannels(matched);
  //   }

  //   // salesman – if id present, find option in `salesMan` list
  //   if (postData.salesman_id && salesMan?.length) {
  //     const found = salesMan.find((s) => s.id === postData.salesman_id);
  //     if (found) {
  //       setPoDetails((prev) => ({ ...prev, salesManId: found }));
  //     }
  //   }
  // }, [postData, salesMan]);
  // Prefill customer + salesman + channel when a parked bill is loaded
  // useEffect(() => {
  //   // nothing to prefill
  //   if (!postData || (!postData.mobile && !postData.party_name)) return;

  //   // 1) Mobile & Customer name (Formik + party state)
  //   formik.setFieldValue("mobile", postData.mobile || "");
  //   formik.setFieldValue("name", postData.party_name || "");

  //   setParty((prev) => ({
  //     ...prev,
  //     name: postData.party_name || "",
  //     mobile: postData.mobile || "",
  //     address: postData.address || "",
  //     gstin: postData.gst_in || "",
  //   }));

  //   // 2) Address textarea
  //   // (already bound to party.address so above setParty handles it)

  //   // 3) Points / This Bill / Total
  //   setPoints(postData.balance_points || 0);
  //   setBillPoints((prev) => ({
  //     ...prev,
  //     total: postData.balance_points || 0,
  //     defaultPoint: postData.loyalty_earned || 0,
  //   }));
  //   setThisBill(postData.loyalty_earned || 0);

  //   // 4) Mode (cash / card / upi / mixed)
  //   if (postData.mode) {
  //     setSelectedMode(postData.mode.toLowerCase());
  //   }

  //   // 5) Channels select
  //   if (postData.channels) {
  //     const matchedChannel = socialMediaPlatforms.find(
  //       (c) => c.fullname === postData.channels
  //     );
  //     if (matchedChannel) {
  //       setChannels(matchedChannel);
  //     }
  //   }

  //   // 6) Salesman autocomplete
  //   if (postData.salesman_id && salesMan?.length) {
  //     const found = salesMan.find((s) => s.id === postData.salesman_id);
  //     if (found) {
  //       setPoDetails((prev) => ({
  //         ...prev,
  //         salesManId: found,
  //       }));
  //     }
  //   }
  //    console.log("useeffect line 3246")
  // }, [postData, salesMan]);
  const hasPrefilled = React.useRef(false);

  useEffect(() => {
    // stop re-running once data is applied
    if (hasPrefilled.current) return;

    // nothing to prefill
    if (!postData || (!postData.mobile && !postData.party_name)) return;

    hasPrefilled.current = true;

    // 1) Mobile & Customer name
    formik.setFieldValue("mobile", postData.mobile || "");
    formik.setFieldValue("name", postData.party_name || "");

    setParty((prev) => ({
      ...prev,
      name: postData.party_name || "",
      mobile: postData.mobile || "",
      address: postData.address || "",
      gstin: postData.gst_in || "",
    }));

    // 3) Points / This Bill / Total
    setPoints(postData.balance_points || 0);
    setBillPoints((prev) => ({
      ...prev,
      total: postData.balance_points || 0,
      defaultPoint: postData.loyalty_earned || 0,
    }));
    setThisBill(postData.loyalty_earned || 0);

    // 4) Mode
    if (postData.mode) {
      setSelectedMode(postData.mode.toLowerCase());
    }

    // 5) Channels
    if (postData.channels) {
      const matchedChannel = socialMediaPlatforms.find(
        (c) => c.fullname === postData.channels,
      );
      if (matchedChannel) {
        setChannels(matchedChannel);
      }
    }

    // 6) Salesman
    if (postData.salesman_id && salesMan?.length) {
      const found = salesMan.find((s) => s.id === postData.salesman_id);
      if (found) {
        setPoDetails((prev) => ({
          ...prev,
          salesManId: found,
        }));
      }
    }

    console.log("useeffect line 3246 - executed once");
  }, [postData, salesMan]);

  useEffect(() => {
    setPostData((prev) => ({
      ...prev,
      mobile: party.mobile || "",
      party_name: party.name || "",
      address: party.address || "",
    }));
  }, [party.mobile, party.name, party.address]);

  useEffect(() => {
    if (onPendingDeleted) {
      onPendingDeleted.current = removePendingBillFromList;
    }
  }, []);

  return (
    <Grid container spacing={2} className="p-2 h-full">
      <Grid item lg={4}>
        <TextField
          autoComplete="off"
          inputRef={mobileRef}
          size="small"
          label="Mobile"
          fullWidth
          name="mobile"
          value={formik.values.mobile}
          onChange={handleOnChange}
          onKeyDown={(e) => handleKeyPress(e, mobileRef, nameRef)}
          error={false}
          helperText=""
          // onBlur={formik.handleBlur}
          onBlur={(e) => {
            formik.handleBlur(e);
            handleCheckReferral(e.target.value);
          }}
          // inputProps={{ maxLength: 10 }}
          inputProps={{
            maxLength: 10,
            inputMode: "numeric",
            pattern: "[0-9]*",
            onInput: (e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            },
          }}
          // error={
          //   formik.touched.mobile &&
          //   !!formik.errors.mobile &&
          //   formik.values.mobile !== ""
          // }
          // helperText={
          //   formik.touched.mobile &&
          //   formik.values.mobile !== "" &&
          //   formik.errors.mobile
          // }
        />
        <TextField
          sx={{ marginBlock: 1.5 }}
          inputRef={nameRef}
          size="small"
          label="Customer Name"
          fullWidth
          name="name"
          value={formik.values.name}
          onChange={handleOnChange}
          disabled={flag}
          onKeyDown={(e) => handleKeyPress(e, nameRef, addressRef)}
          onBlur={formik.handleBlur}
          error={
            formik.touched.name &&
            Boolean(formik.errors.name) &&
            formik.values.mobile !== ""
          }
          helperText={
            formik.touched.name &&
            formik.errors.name &&
            formik.values.mobile !== ""
              ? formik.errors.name
              : ""
          }
        />
        <TextField
          inputRef={addressRef}
          size="small"
          label="Address"
          fullWidth
          name="address"
          multiline
          sx={{ marginBottom: 1.5 }}
          value={party.address}
          onChange={handleOnChange}
          disabled={flag}
          onKeyDown={(e) => handleKeyPress(e, addressRef, salesmanRef)}
        />
        <div className="flex">
          <TextField
            size="small"
            label="Points"
            name="points"
            value={points}
            InputProps={{ readOnly: true }}
            disabled={!flag}
            sx={{ marginInline: 0.5 }}
          />
          <TextField
            size="small"
            label="This Bill"
            name="billPoints"
            value={parseFloat(thisBill).toFixed(0)}
            InputProps={{ readOnly: true }}
            disabled={!flag}
            sx={{ marginInline: 0.5 }}
          />
          <TextField
            size="small"
            label="Total"
            name="Total"
            value={parseFloat(billPoints.total).toFixed(0)}
            InputProps={{ readOnly: true }}
            disabled={!flag}
            sx={{ marginInline: 0.5 }}
          />
        </div>
        {otpEnable && party.mobile !== "" && (
          <Button
            onClick={handleOtp}
            variant={otpDisable ? "" : "contained"}
            disabled={otpDisable}
            sx={{ marginBlock: "10px" }}
          >
            Send Otp for redeem points
          </Button>
        )}
        <TextField
          size="small"
          label="S.No"
          fullWidth
          name="slipNo"
          value={slipNo}
          onChange={handleOnChange}
          onBlur={(e) => {
            const value = e.target.value;
            if (value) {
              handleCheckDuplicateSno(value);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const value = e.target.value;
              if (value) {
                handleCheckDuplicateSno(value);
              }
            }
          }}
          required
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            onInput: (e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            },
          }}
          error={formik.touched.slipNo && Boolean(formik.errors.slipNo)}
          helperText={formik.touched.slipNo && formik.errors.slipNo}
          sx={{ marginInline: 0.5, mt: 3 }}
        />
      </Grid>
      <Grid item lg={4}>
        {otName !== "OWN" && (
          <TextField
            size="small"
            label="GSTIN"
            fullWidth
            name="gstin"
            value={party.gstin}
            onChange={handleOnChange}
          />
        )}
        <Typography variant="body1">Mode</Typography>
        <FormControl sx={{ display: "flex" }}>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="mode"
            id="mode"
            sx={{ flexDirection: "row", display: "flex" }}
            value={selectedMode}
            onChange={handleModeChange}
          >
            <FormControlLabel
              value="cash"
              control={<Radio size="small" />}
              label="Cash"
            />
            <FormControlLabel
              value="card"
              control={<Radio size="small" />}
              label="Card"
            />
            <FormControlLabel
              value="upi"
              control={<Radio size="small" />}
              label="UPI"
            />
            <FormControlLabel
              value="mixed"
              control={<Radio size="small" />}
              label="Mixed Pay"
            />
            {/* <FormControlLabel value="edc" control={<Radio />} label="EDC" /> */}
          </RadioGroup>
        </FormControl>
        {/* <Autocomplete
          options={filteredReturnDocNoList}
          loading={returnDocNoLoading}
          getOptionLabel={(option) => (option.docno ? option.docno : "")}
          getOptionDisabled={(option) => option.disabled}
          value={
            filteredReturnDocNoList.find((opt) => opt.docno === billNo) || null
          }
          onChange={(e, value) => {
            if (data.length === 0) {
              dispatch(
                setSnackbar(true, "error", "please sale any one product")
              );
            } else if (value?.docno && value.docno !== usedReturnBill) {
              onReturnBillUsed(value.docno);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label="Return bill"
              fullWidth
              sx={{ marginBottom: 1.5 }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onReturnBillUsed(params.inputProps.value);
                }
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {returnDocNoLoading ? (
                      <span style={{ marginRight: 8 }}>
                        <i className="fa fa-spinner fa-spin" />
                      </span>
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          isOptionEqualToValue={(option, value) => option.docno === value.docno}
        /> */}
        {/* <Autocomplete
  options={filteredReturnDocNoList}
  loading={returnDocNoLoading}
  getOptionLabel={(option) => (option.docno ? option.docno : "")}
  value={
    // ✅ FIXED: Clear value when no matching option exists OR billNo is cleared
    billNo && !returnDocNoLoading 
      ? filteredReturnDocNoList.find((opt) => opt.docno === billNo) || null 
      : null
  }
  onChange={(e, value) => {
    if (data.length === 0) {
      dispatch(setSnackbar(true, "error", "please sale any one product"));
      return;
    }
    // ✅ FIXED: Clear selection properly
    if (value?.docno) {
      onReturnBillUsed(value.docno);
    } else {
      // Clear billNo when selection is removed
      setBillNo("");
      setUsedReturnBill(null);
      setReturnData([]);
      setReturnBar([]);
      setReturnAmnt(0);
    }
  }}
  freeSolo={false}
  disableClearable={false} // ✅ Allow clearing
  openOnFocus={true}
  multiple={false}
  // ✅ FIXED: Only disable PREVIOUSLY used bills, not current selection
  getOptionDisabled={(option) => option.docno !== billNo && usedReturnBill === option.docno}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      label="Return bill"
      fullWidth
      sx={{ marginBottom: 1.5 }}
      InputProps={{
        ...params.InputProps,
        readOnly: true,
        endAdornment: (
          <>
            {returnDocNoLoading ? (
              <span style={{ marginRight: 8 }}>
                <i className="fa fa-spinner fa-spin" />
              </span>
            ) : null}
            {params.InputProps.endAdornment}
          </>
        ),
      }}
      onKeyDown={(e) => {
        if (data.length === 0 && e.key === 'Enter') {
          e.preventDefault();
          dispatch(setSnackbar(true, "error", "please sale any one product"));
        }
      }}
    />
  )}
  isOptionEqualToValue={(option, value) => option.docno === value?.docno}
  ListboxProps={{
    disableListWrap: true,
  }}
/> */}

        <Autocomplete
          options={filteredReturnDocNoList}
          loading={returnDocNoLoading}
          getOptionLabel={(option) => (option?.docno ? option.docno : "")}
          value={
            billNo && !returnDocNoLoading
              ? filteredReturnDocNoList.find((opt) => opt.docno === billNo) ||
                null
              : null
          }
          freeSolo={false}
          disableClearable={false}
          selectOnFocus={false}
          clearOnBlur={false}
          handleHomeEndKeys={false}
          inputValue={billNo ? billNo : ""}
          onInputChange={(event, newInputValue, reason) => {
            if (reason === "input") {
              return;
            }
          }}
          onChange={(e, value) => {
            if (data.length === 0) {
              dispatch(
                setSnackbar(true, "error", "please sale any one product"),
              );
              return;
            }

            if (value?.docno) {
              onReturnBillUsed(value.docno);
            } else {
              setBillNo("");
              setUsedReturnBill(null);
              setReturnData([]);
              setReturnBar([]);
              setReturnAmnt(0);
            }
          }}
          getOptionDisabled={(option) =>
            option.docno !== billNo && usedReturnBill === option.docno
          }
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label="Return bill"
              fullWidth
              sx={{ marginBottom: 1.5 }}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {returnDocNoLoading ? (
                      <span style={{ marginRight: 8 }}>
                        <i className="fa fa-spinner fa-spin" />
                      </span>
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              onKeyDown={(e) => {
                if (data.length === 0 && e.key === "Enter") {
                  e.preventDefault();
                  dispatch(
                    setSnackbar(true, "error", "please sale any one product"),
                  );
                }
              }}
            />
          )}
          isOptionEqualToValue={(option, value) =>
            option.docno === value?.docno
          }
          ListboxProps={{
            disableListWrap: true,
          }}
        />

        <Autocomplete
          options={returnData}
          multiple={true}
          disableClearable
          limitTags={3}
          size="small"
          value={returnBar}
          getOptionLabel={(option) => option.barcode}
          onChange={(e, value) => setReturnBar(value)}
          isOptionEqualToValue={(option, value) =>
            option.barcode === value.barcode
          }
          disabled={returnData.length === 0}
          sx={{ marginBlock: 1 }}
          renderInput={(params) => (
            <TextField {...params} label="Select Barcode" autoComplete="off" />
          )}
        />

        <TextField
          size="small"
          // label="Referrer Mobile No"
          label="Referee Mobile No"
          fullWidth
          // value={referrerMobile}
          // onChange={handleReferrerChange}
          // error={Boolean(referrerError)}
          // helperText={referrerError}
          onChange={handleRefereeChange}
          value={refereeMobile}
          error={Boolean(refereeError)}
          helperText={refereeError}
          inputProps={{ maxLength: 10 }}
          sx={{ marginBottom: 1.5 }}
          // disabled={channels?.fullname?.toLowerCase() === "regular"}
        />
        {/* <Button
          fullWidth
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "ba68c8",
            fontWeight: 600,
            textTransform: "none",
            mb: 1,
          }}
          onClick={handleOpenPendingBills}
        >
          Pending Bills
        </Button> */}
        <TextField
          size="small"
          label="Referee Name"
          fullWidth
          onChange={handleRefereeNameChange}
          value={refereeName}
          sx={{ marginBottom: 1.5 }}
        />
      </Grid>
      <Grid item lg={4}>
        <TextField
          size="small"
          label="Bill No"
          fullWidth
          value={docName.replace(/\/(\d+)\/(\d+)\//, "/$1-$2/")}
          InputProps={{ readOnly: true }}
        />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            onChange={(e) => handleChange(e)}
            value={dayjs(poDetails.docDate)}
            label="Bill Date"
            disabled
            slotProps={{
              textField: {
                size: "small",
              },
            }}
            sx={{ width: "100%", marginBlock: 1.5 }}
          />
        </LocalizationProvider>
        <Autocomplete
          id="salesman"
          name="salesman"
          size="small"
          options={salesMan}
          getOptionLabel={(option) =>
            `${option.sales_man_name} - ${option.sales_man_code}`
          }
          value={poDetails.salesManId}
          onChange={handleSalesMan}
          disableClearable
          isOptionEqualToValue={(option, value) => option.id === value.id}
          sx={{ marginBlock: 1 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Salesman"
              autoComplete="off"
              inputRef={salesmanRef}
            />
          )}
        />
        {/* CHANGED: CHANNELS Autocomplete - Proper default and null handling */}
        <Autocomplete
          size="small"
          options={socialMediaPlatforms}
          required
          disableClearable
          value={channels}
          sx={{ marginBlock: 1 }}
          onChange={(e, value) => {
            setChannels(value);
          }}
          getOptionLabel={(option) => option.fullname || ""}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Channels"
              placeholder={channels === null ? "Please select channel" : ""}
              InputProps={{
                ...params.InputProps,
                value: channels?.fullname || "",
              }}
            />
          )}
          // disabled={points > 0}
          disabled={points > 0 && !postData.is_referral_customer}
        />
        <Typography
          sx={{
            fontWeight: "bold",
            textAlign: "right",
            backgroundColor: "#ba68c8",
            color: "#fff",
            padding: "8px 20px",
          }}
        >
          {subCatName} Total available Qty is : {count}
        </Typography>

        <Button
          fullWidth
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "ba68c8",
            fontWeight: 600,
            textTransform: "none",
            mb: 1,
            mt: 2,
          }}
          onClick={handleOpenPendingBills}
        >
          Pending Bills
        </Button>
      </Grid>
      <Dialog
        open={otpOpen}
        sx={{ width: "800px !important", margin: "0 auto" }}
      >
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Typography
            sx={{
              fontSize: 20,
              color: "#004AAD",
              fontWeight: "bold",
              marginRight: "50px",
            }}
          >
            please enter the OTP for this number
            <span style={{ fontSize: 20, color: "#000", fontWeight: "bold" }}>
              {party.mobile}
            </span>
          </Typography>
          <IconButton onClick={() => setOtpOpen(false)}>
            <Close />
          </IconButton>
        </Grid>
        <Divider />
        <Grid sx={{ padding: "20px" }}>
          <OTPInput
            shouldAutoFocus
            name="otp"
            id="otp"
            containerStyle={classes.otpContainer}
            inputStyle={classes.otpField}
            onChange={(otp) => formik.setFieldValue("otp", otp)}
            numInputs={4}
            renderInput={(props) => <input {...props} />}
            value={formik.values.otp}
            error={formik.touched.otp && Boolean(formik.errors.otp)}
            helperText={formik.touched.otp && formik.errors.otp}
          />
          <Grid sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              // onClick={formik.handleSubmit}
              onClick={() => formik.handleSubmit()}
            >
              Verify OTP
            </Button>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={showPendingBills}
        onClose={() => setShowPendingBills(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            m: 0,
            px: 2,
            py: 1.5,
            bgcolor: "#ba68c8",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: 600,
          }}
        >
          Pending bills
          <IconButton
            size="small"
            onClick={() => setShowPendingBills(false)}
            sx={{ color: "#fff" }}
          >
            <Close fontSize="small" />
          </IconButton>
        </DialogTitle>

        {/* Content */}
        <DialogContent
          sx={{
            p: 0,
            bgcolor: "#fafafa",
          }}
        >
          {pendingLoading ? (
            <Typography sx={{ p: 2, textAlign: "center" }}>
              Loading...
            </Typography>
          ) : pendingBills.length === 0 ? (
            <Typography sx={{ p: 2, textAlign: "center" }}>
              No parked bills found.
            </Typography>
          ) : (
            <TableContainer component={Paper} elevation={0}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600 }}>Customer</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Bill No</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Mobile</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Amount</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingBills.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell>{row.party_name || "Walk-in"}</TableCell>
                      <TableCell>{row.docno}</TableCell>
                      <TableCell>{row.mobile}</TableCell>
                      <TableCell>₹ {row.amount}</TableCell>
                      <TableCell>
                        {moment(row.docdate).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          variant="outlined"
                          size="small"
                          sx={{
                            textTransform: "none",
                            borderRadius: 999,
                            px: 2,
                            borderColor: "#ba68c8",
                            color: "#ba68c8",
                            "&:hover": {
                              borderColor: "#ab47bc",
                              bgcolor: "#f3e5f5",
                            },
                          }}
                          onClick={() => {
                            onLoadPending(row);
                            setShowPendingBills(false); // close dialog
                          }}
                        >
                          Load
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            px: 2,
            py: 1,
            borderTop: "1px solid #eee",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {pendingBills.length} pending bill(s)
          </Typography>
          <Button onClick={() => setShowPendingBills(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default memo(SalesInfo);
